
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire035d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire035d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



parcelRequire("acw62");
/**
 * react-router v7.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $c700d8a3a13e01e9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-LFPYN7LY.mjs"
});
var $c700d8a3a13e01e9$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $c700d8a3a13e01e9$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $c700d8a3a13e01e9$var$__typeError("Cannot " + msg);
var $c700d8a3a13e01e9$var$__privateGet = (obj, member, getter)=>($c700d8a3a13e01e9$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $c700d8a3a13e01e9$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $c700d8a3a13e01e9$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $c700d8a3a13e01e9$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($c700d8a3a13e01e9$export$e19cd5f9376f8cee || {});
var $c700d8a3a13e01e9$var$PopStateEventType = "popstate";
function $c700d8a3a13e01e9$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $c700d8a3a13e01e9$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $c700d8a3a13e01e9$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $c700d8a3a13e01e9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $c700d8a3a13e01e9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $c700d8a3a13e01e9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $c700d8a3a13e01e9$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $c700d8a3a13e01e9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    }
    return $c700d8a3a13e01e9$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $c700d8a3a13e01e9$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $c700d8a3a13e01e9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $c700d8a3a13e01e9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $c700d8a3a13e01e9$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $c700d8a3a13e01e9$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $c700d8a3a13e01e9$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $c700d8a3a13e01e9$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $c700d8a3a13e01e9$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $c700d8a3a13e01e9$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $c700d8a3a13e01e9$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $c700d8a3a13e01e9$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $c700d8a3a13e01e9$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $c700d8a3a13e01e9$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $c700d8a3a13e01e9$var$isLocation(to) ? to : $c700d8a3a13e01e9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $c700d8a3a13e01e9$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $c700d8a3a13e01e9$var$isLocation(to) ? to : $c700d8a3a13e01e9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $c700d8a3a13e01e9$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $c700d8a3a13e01e9$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($c700d8a3a13e01e9$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($c700d8a3a13e01e9$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $c700d8a3a13e01e9$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $c700d8a3a13e01e9$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $c700d8a3a13e01e9$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $c700d8a3a13e01e9$var$_map;
var $c700d8a3a13e01e9$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $c700d8a3a13e01e9$var$__privateAdd(this, $c700d8a3a13e01e9$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($c700d8a3a13e01e9$var$__privateGet(this, $c700d8a3a13e01e9$var$_map).has(context)) return $c700d8a3a13e01e9$var$__privateGet(this, $c700d8a3a13e01e9$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $c700d8a3a13e01e9$var$__privateGet(this, $c700d8a3a13e01e9$var$_map).set(context, value);
    }
};
$c700d8a3a13e01e9$var$_map = new WeakMap();
var $c700d8a3a13e01e9$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $c700d8a3a13e01e9$var$isUnsupportedLazyRouteObjectKey(key) {
    return $c700d8a3a13e01e9$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $c700d8a3a13e01e9$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $c700d8a3a13e01e9$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $c700d8a3a13e01e9$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $c700d8a3a13e01e9$var$isIndexRoute(route) {
    return route.index === true;
}
function $c700d8a3a13e01e9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $c700d8a3a13e01e9$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $c700d8a3a13e01e9$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($c700d8a3a13e01e9$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $c700d8a3a13e01e9$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $c700d8a3a13e01e9$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $c700d8a3a13e01e9$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $c700d8a3a13e01e9$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $c700d8a3a13e01e9$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $c700d8a3a13e01e9$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $c700d8a3a13e01e9$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $c700d8a3a13e01e9$var$flattenRoutes(routes);
    $c700d8a3a13e01e9$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $c700d8a3a13e01e9$var$decodePath(pathname);
        matches = $c700d8a3a13e01e9$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $c700d8a3a13e01e9$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $c700d8a3a13e01e9$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $c700d8a3a13e01e9$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $c700d8a3a13e01e9$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $c700d8a3a13e01e9$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $c700d8a3a13e01e9$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $c700d8a3a13e01e9$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $c700d8a3a13e01e9$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $c700d8a3a13e01e9$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $c700d8a3a13e01e9$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $c700d8a3a13e01e9$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $c700d8a3a13e01e9$var$paramRe = /^:[\w-]+$/;
var $c700d8a3a13e01e9$var$dynamicSegmentValue = 3;
var $c700d8a3a13e01e9$var$indexRouteValue = 2;
var $c700d8a3a13e01e9$var$emptySegmentValue = 1;
var $c700d8a3a13e01e9$var$staticSegmentValue = 10;
var $c700d8a3a13e01e9$var$splatPenalty = -2;
var $c700d8a3a13e01e9$var$isSplat = (s)=>s === "*";
function $c700d8a3a13e01e9$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($c700d8a3a13e01e9$var$isSplat)) initialScore += $c700d8a3a13e01e9$var$splatPenalty;
    if (index) initialScore += $c700d8a3a13e01e9$var$indexRouteValue;
    return segments.filter((s)=>!$c700d8a3a13e01e9$var$isSplat(s)).reduce((score, segment)=>score + ($c700d8a3a13e01e9$var$paramRe.test(segment) ? $c700d8a3a13e01e9$var$dynamicSegmentValue : segment === "" ? $c700d8a3a13e01e9$var$emptySegmentValue : $c700d8a3a13e01e9$var$staticSegmentValue), initialScore);
}
function $c700d8a3a13e01e9$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $c700d8a3a13e01e9$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $c700d8a3a13e01e9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $c700d8a3a13e01e9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $c700d8a3a13e01e9$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $c700d8a3a13e01e9$var$normalizePathname($c700d8a3a13e01e9$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $c700d8a3a13e01e9$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $c700d8a3a13e01e9$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $c700d8a3a13e01e9$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $c700d8a3a13e01e9$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $c700d8a3a13e01e9$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $c700d8a3a13e01e9$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $c700d8a3a13e01e9$var$compilePath(path, caseSensitive = false, end = true) {
    $c700d8a3a13e01e9$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $c700d8a3a13e01e9$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $c700d8a3a13e01e9$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $c700d8a3a13e01e9$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $c700d8a3a13e01e9$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
        basename,
        pathname
    ]);
}
var $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c700d8a3a13e01e9$var$isAbsoluteUrl = (url)=>$c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX.test(url);
function $c700d8a3a13e01e9$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = toPathname.replace(/\/\/+/g, "/");
        if (toPathname.startsWith("/")) pathname = $c700d8a3a13e01e9$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $c700d8a3a13e01e9$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $c700d8a3a13e01e9$var$normalizeSearch(search),
        hash: $c700d8a3a13e01e9$var$normalizeHash(hash)
    };
}
function $c700d8a3a13e01e9$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $c700d8a3a13e01e9$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $c700d8a3a13e01e9$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $c700d8a3a13e01e9$var$getResolveToMatches(matches) {
    let pathMatches = $c700d8a3a13e01e9$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $c700d8a3a13e01e9$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $c700d8a3a13e01e9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $c700d8a3a13e01e9$var$getInvalidPathError("?", "pathname", "search", to));
        $c700d8a3a13e01e9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $c700d8a3a13e01e9$var$getInvalidPathError("#", "pathname", "hash", to));
        $c700d8a3a13e01e9$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $c700d8a3a13e01e9$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $c700d8a3a13e01e9$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $c700d8a3a13e01e9$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $c700d8a3a13e01e9$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $c700d8a3a13e01e9$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $c700d8a3a13e01e9$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $c700d8a3a13e01e9$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $c700d8a3a13e01e9$export$4051a07651545597(data2, init) {
    return new $c700d8a3a13e01e9$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $c700d8a3a13e01e9$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $c700d8a3a13e01e9$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $c700d8a3a13e01e9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $c700d8a3a13e01e9$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $c700d8a3a13e01e9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $c700d8a3a13e01e9$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $c700d8a3a13e01e9$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $c700d8a3a13e01e9$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $c700d8a3a13e01e9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $c700d8a3a13e01e9$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($c700d8a3a13e01e9$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $c700d8a3a13e01e9$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $c700d8a3a13e01e9$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $c700d8a3a13e01e9$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $c700d8a3a13e01e9$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $c700d8a3a13e01e9$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $c700d8a3a13e01e9$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $c700d8a3a13e01e9$var$wrapImpl(aggregated[key], original, (...args)=>$c700d8a3a13e01e9$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $c700d8a3a13e01e9$var$wrapImpl(aggregated.middleware, original, (...args)=>$c700d8a3a13e01e9$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $c700d8a3a13e01e9$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $c700d8a3a13e01e9$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $c700d8a3a13e01e9$export$fe53371bee54353d(to) : ".",
                ...$c700d8a3a13e01e9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$c700d8a3a13e01e9$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $c700d8a3a13e01e9$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$c700d8a3a13e01e9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$c700d8a3a13e01e9$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $c700d8a3a13e01e9$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $c700d8a3a13e01e9$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $c700d8a3a13e01e9$var$getReadonlyRequest(request),
            context: context != null ? $c700d8a3a13e01e9$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $c700d8a3a13e01e9$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $c700d8a3a13e01e9$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $c700d8a3a13e01e9$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $c700d8a3a13e01e9$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $c700d8a3a13e01e9$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $c700d8a3a13e01e9$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $c700d8a3a13e01e9$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $c700d8a3a13e01e9$var$getReadonlyContext(context)
    };
}
function $c700d8a3a13e01e9$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $c700d8a3a13e01e9$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $c700d8a3a13e01e9$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $c700d8a3a13e01e9$var$getReadonlyContext(context) {
    if ($c700d8a3a13e01e9$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $c700d8a3a13e01e9$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $c700d8a3a13e01e9$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $c700d8a3a13e01e9$var$objectProtoNames;
}
// lib/router/router.ts
var $c700d8a3a13e01e9$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $c700d8a3a13e01e9$var$validMutationMethods = new Set($c700d8a3a13e01e9$var$validMutationMethodsArr);
var $c700d8a3a13e01e9$var$validRequestMethodsArr = [
    "GET",
    ...$c700d8a3a13e01e9$var$validMutationMethodsArr
];
var $c700d8a3a13e01e9$var$validRequestMethods = new Set($c700d8a3a13e01e9$var$validRequestMethodsArr);
var $c700d8a3a13e01e9$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $c700d8a3a13e01e9$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $c700d8a3a13e01e9$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $c700d8a3a13e01e9$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $c700d8a3a13e01e9$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $c700d8a3a13e01e9$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $c700d8a3a13e01e9$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $c700d8a3a13e01e9$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $c700d8a3a13e01e9$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $c700d8a3a13e01e9$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $c700d8a3a13e01e9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$c700d8a3a13e01e9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $c700d8a3a13e01e9$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $c700d8a3a13e01e9$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = relevantMatches.every((m)=>{
                let status = $c700d8a3a13e01e9$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                return !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $c700d8a3a13e01e9$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $c700d8a3a13e01e9$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $c700d8a3a13e01e9$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $c700d8a3a13e01e9$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$c700d8a3a13e01e9$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $c700d8a3a13e01e9$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $c700d8a3a13e01e9$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $c700d8a3a13e01e9$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $c700d8a3a13e01e9$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $c700d8a3a13e01e9$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $c700d8a3a13e01e9$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $c700d8a3a13e01e9$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $c700d8a3a13e01e9$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $c700d8a3a13e01e9$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $c700d8a3a13e01e9$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $c700d8a3a13e01e9$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $c700d8a3a13e01e9$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $c700d8a3a13e01e9$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($c700d8a3a13e01e9$var$isErrorResult(result) && $c700d8a3a13e01e9$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $c700d8a3a13e01e9$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$c700d8a3a13e01e9$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $c700d8a3a13e01e9$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $c700d8a3a13e01e9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $c700d8a3a13e01e9$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $c700d8a3a13e01e9$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $c700d8a3a13e01e9$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $c700d8a3a13e01e9$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $c700d8a3a13e01e9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $c700d8a3a13e01e9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$c700d8a3a13e01e9$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $c700d8a3a13e01e9$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $c700d8a3a13e01e9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $c700d8a3a13e01e9$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $c700d8a3a13e01e9$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $c700d8a3a13e01e9$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $c700d8a3a13e01e9$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c700d8a3a13e01e9$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $c700d8a3a13e01e9$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($c700d8a3a13e01e9$var$isRedirectResult(actionResult) || $c700d8a3a13e01e9$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($c700d8a3a13e01e9$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $c700d8a3a13e01e9$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($c700d8a3a13e01e9$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $c700d8a3a13e01e9$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $c700d8a3a13e01e9$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $c700d8a3a13e01e9$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $c700d8a3a13e01e9$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $c700d8a3a13e01e9$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $c700d8a3a13e01e9$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $c700d8a3a13e01e9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $c700d8a3a13e01e9$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $c700d8a3a13e01e9$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $c700d8a3a13e01e9$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $c700d8a3a13e01e9$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $c700d8a3a13e01e9$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
            return;
        }
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $c700d8a3a13e01e9$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $c700d8a3a13e01e9$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $c700d8a3a13e01e9$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($c700d8a3a13e01e9$var$isAbsoluteUrl(location)) {
                const url = $c700d8a3a13e01e9$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $c700d8a3a13e01e9$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $c700d8a3a13e01e9$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($c700d8a3a13e01e9$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $c700d8a3a13e01e9$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $c700d8a3a13e01e9$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($c700d8a3a13e01e9$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $c700d8a3a13e01e9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $c700d8a3a13e01e9$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $c700d8a3a13e01e9$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $c700d8a3a13e01e9$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $c700d8a3a13e01e9$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $c700d8a3a13e01e9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $c700d8a3a13e01e9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $c700d8a3a13e01e9$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $c700d8a3a13e01e9$export$386d57f03f0b2883;
        $c700d8a3a13e01e9$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $c700d8a3a13e01e9$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $c700d8a3a13e01e9$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$c700d8a3a13e01e9$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $c700d8a3a13e01e9$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $c700d8a3a13e01e9$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $c700d8a3a13e01e9$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $c700d8a3a13e01e9$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $c700d8a3a13e01e9$export$3336b097a6fbc59a(routes, opts) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $c700d8a3a13e01e9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$c700d8a3a13e01e9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $c700d8a3a13e01e9$var$createLocation("", $c700d8a3a13e01e9$export$fe53371bee54353d(url), null, "default");
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        if (!$c700d8a3a13e01e9$var$isValidMethod(method) && method !== "HEAD") {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $c700d8a3a13e01e9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(requestContext instanceof $c700d8a3a13e01e9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $c700d8a3a13e01e9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $c700d8a3a13e01e9$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($c700d8a3a13e01e9$export$6e80290866a84dd4(error)) return error;
                    if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $c700d8a3a13e01e9$export$f2680fa305b734ca(error.status, error.statusText, await $c700d8a3a13e01e9$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(error)) error = $c700d8a3a13e01e9$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $c700d8a3a13e01e9$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $c700d8a3a13e01e9$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $c700d8a3a13e01e9$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $c700d8a3a13e01e9$var$createLocation("", $c700d8a3a13e01e9$export$fe53371bee54353d(url), null, "default");
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $c700d8a3a13e01e9$export$b8d3e69d4b3eff04();
        if (!$c700d8a3a13e01e9$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $c700d8a3a13e01e9$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $c700d8a3a13e01e9$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $c700d8a3a13e01e9$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $c700d8a3a13e01e9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $c700d8a3a13e01e9$export$f5708dca728d7177(requestContext instanceof $c700d8a3a13e01e9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $c700d8a3a13e01e9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $c700d8a3a13e01e9$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($c700d8a3a13e01e9$var$dataWithResponseInitToResponse(error));
                if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $c700d8a3a13e01e9$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $c700d8a3a13e01e9$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($c700d8a3a13e01e9$var$isDataStrategyResult(e) && $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($c700d8a3a13e01e9$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $c700d8a3a13e01e9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($c700d8a3a13e01e9$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c700d8a3a13e01e9$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $c700d8a3a13e01e9$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $c700d8a3a13e01e9$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $c700d8a3a13e01e9$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $c700d8a3a13e01e9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $c700d8a3a13e01e9$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $c700d8a3a13e01e9$var$callDataStrategyImpl(dataStrategy || $c700d8a3a13e01e9$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($c700d8a3a13e01e9$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $c700d8a3a13e01e9$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result.result)) throw $c700d8a3a13e01e9$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $c700d8a3a13e01e9$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $c700d8a3a13e01e9$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $c700d8a3a13e01e9$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $c700d8a3a13e01e9$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $c700d8a3a13e01e9$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $c700d8a3a13e01e9$var$resolveTo(to ? to : ".", $c700d8a3a13e01e9$var$getResolveToMatches(contextualMatches), $c700d8a3a13e01e9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $c700d8a3a13e01e9$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $c700d8a3a13e01e9$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $c700d8a3a13e01e9$export$fe53371bee54353d(path);
}
function $c700d8a3a13e01e9$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$c700d8a3a13e01e9$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$c700d8a3a13e01e9$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $c700d8a3a13e01e9$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $c700d8a3a13e01e9$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $c700d8a3a13e01e9$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$c700d8a3a13e01e9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$c700d8a3a13e01e9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $c700d8a3a13e01e9$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $c700d8a3a13e01e9$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $c700d8a3a13e01e9$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $c700d8a3a13e01e9$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $c700d8a3a13e01e9$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $c700d8a3a13e01e9$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $c700d8a3a13e01e9$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $c700d8a3a13e01e9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $c700d8a3a13e01e9$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $c700d8a3a13e01e9$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($c700d8a3a13e01e9$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($c700d8a3a13e01e9$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $c700d8a3a13e01e9$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $c700d8a3a13e01e9$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $c700d8a3a13e01e9$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($c700d8a3a13e01e9$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $c700d8a3a13e01e9$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$c700d8a3a13e01e9$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $c700d8a3a13e01e9$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $c700d8a3a13e01e9$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $c700d8a3a13e01e9$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $c700d8a3a13e01e9$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $c700d8a3a13e01e9$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$c700d8a3a13e01e9$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $c700d8a3a13e01e9$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $c700d8a3a13e01e9$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$c700d8a3a13e01e9$var$isSameRoute(aChild, bChild))) ?? false;
}
var $c700d8a3a13e01e9$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $c700d8a3a13e01e9$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $c700d8a3a13e01e9$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $c700d8a3a13e01e9$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $c700d8a3a13e01e9$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $c700d8a3a13e01e9$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $c700d8a3a13e01e9$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $c700d8a3a13e01e9$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $c700d8a3a13e01e9$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $c700d8a3a13e01e9$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $c700d8a3a13e01e9$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $c700d8a3a13e01e9$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $c700d8a3a13e01e9$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $c700d8a3a13e01e9$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $c700d8a3a13e01e9$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $c700d8a3a13e01e9$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $c700d8a3a13e01e9$var$isNonNullable(value) {
    return value !== void 0;
}
function $c700d8a3a13e01e9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $c700d8a3a13e01e9$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($c700d8a3a13e01e9$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $c700d8a3a13e01e9$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $c700d8a3a13e01e9$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $c700d8a3a13e01e9$var$defaultDataStrategy(args);
    return $c700d8a3a13e01e9$var$runClientMiddlewarePipeline(args, ()=>$c700d8a3a13e01e9$var$defaultDataStrategy(args));
}
function $c700d8a3a13e01e9$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $c700d8a3a13e01e9$var$runMiddlewarePipeline(args, handler, processResult, $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result) ? $c700d8a3a13e01e9$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $c700d8a3a13e01e9$var$runClientMiddlewarePipeline(args, handler) {
    return $c700d8a3a13e01e9$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($c700d8a3a13e01e9$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $c700d8a3a13e01e9$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $c700d8a3a13e01e9$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $c700d8a3a13e01e9$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $c700d8a3a13e01e9$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $c700d8a3a13e01e9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $c700d8a3a13e01e9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $c700d8a3a13e01e9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $c700d8a3a13e01e9$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $c700d8a3a13e01e9$var$loadLazyRoute(match.route, $c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $c700d8a3a13e01e9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $c700d8a3a13e01e9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $c700d8a3a13e01e9$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $c700d8a3a13e01e9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $c700d8a3a13e01e9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $c700d8a3a13e01e9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $c700d8a3a13e01e9$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $c700d8a3a13e01e9$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $c700d8a3a13e01e9$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $c700d8a3a13e01e9$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $c700d8a3a13e01e9$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $c700d8a3a13e01e9$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $c700d8a3a13e01e9$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $c700d8a3a13e01e9$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $c700d8a3a13e01e9$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $c700d8a3a13e01e9$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $c700d8a3a13e01e9$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $c700d8a3a13e01e9$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $c700d8a3a13e01e9$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $c700d8a3a13e01e9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $c700d8a3a13e01e9$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$c700d8a3a13e01e9$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $c700d8a3a13e01e9$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $c700d8a3a13e01e9$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($c700d8a3a13e01e9$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $c700d8a3a13e01e9$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $c700d8a3a13e01e9$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($c700d8a3a13e01e9$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $c700d8a3a13e01e9$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $c700d8a3a13e01e9$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $c700d8a3a13e01e9$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $c700d8a3a13e01e9$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $c700d8a3a13e01e9$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $c700d8a3a13e01e9$export$f5708dca728d7177(!$c700d8a3a13e01e9$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $c700d8a3a13e01e9$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $c700d8a3a13e01e9$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $c700d8a3a13e01e9$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $c700d8a3a13e01e9$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $c700d8a3a13e01e9$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($c700d8a3a13e01e9$var$isErrorResult(result)) {
            let boundaryMatch = $c700d8a3a13e01e9$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($c700d8a3a13e01e9$var$isRedirectResult(result)) $c700d8a3a13e01e9$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $c700d8a3a13e01e9$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $c700d8a3a13e01e9$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $c700d8a3a13e01e9$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $c700d8a3a13e01e9$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $c700d8a3a13e01e9$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $c700d8a3a13e01e9$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $c700d8a3a13e01e9$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $c700d8a3a13e01e9$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $c700d8a3a13e01e9$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $c700d8a3a13e01e9$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($c700d8a3a13e01e9$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $c700d8a3a13e01e9$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(path) : path;
    return $c700d8a3a13e01e9$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $c700d8a3a13e01e9$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $c700d8a3a13e01e9$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $c700d8a3a13e01e9$var$dataWithResponseInitToErrorResponse(data2) {
    return new $c700d8a3a13e01e9$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $c700d8a3a13e01e9$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $c700d8a3a13e01e9$var$isDataStrategyResult(value));
}
function $c700d8a3a13e01e9$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $c700d8a3a13e01e9$var$isRedirectDataStrategyResult(result) {
    return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result.result) && $c700d8a3a13e01e9$var$redirectStatusCodes.has(result.result.status);
}
function $c700d8a3a13e01e9$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $c700d8a3a13e01e9$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $c700d8a3a13e01e9$export$794b2760043cf8cd(statusCode) {
    return $c700d8a3a13e01e9$var$redirectStatusCodes.has(statusCode);
}
function $c700d8a3a13e01e9$export$6e80290866a84dd4(result) {
    return $c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result) && $c700d8a3a13e01e9$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $c700d8a3a13e01e9$var$isValidMethod(method) {
    return $c700d8a3a13e01e9$var$validRequestMethods.has(method.toUpperCase());
}
function $c700d8a3a13e01e9$export$cbae47800eb95bc3(method) {
    return $c700d8a3a13e01e9$var$validMutationMethods.has(method.toUpperCase());
}
function $c700d8a3a13e01e9$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $c700d8a3a13e01e9$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $c700d8a3a13e01e9$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $c700d8a3a13e01e9$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $c700d8a3a13e01e9$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $c700d8a3a13e01e9$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $c700d8a3a13e01e9$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $c700d8a3a13e01e9$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $c700d8a3a13e01e9$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $c700d8a3a13e01e9$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $c700d8a3a13e01e9$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($c700d8a3a13e01e9$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $c700d8a3a13e01e9$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($c700d8a3a13e01e9$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $c700d8a3a13e01e9$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $c700d8a3a13e01e9$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $c700d8a3a13e01e9$export$2eeee58951ff3c1c = $acw62.createContext(null);
$c700d8a3a13e01e9$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $c700d8a3a13e01e9$export$315e3ffb01f217 = $acw62.createContext(null);
$c700d8a3a13e01e9$export$315e3ffb01f217.displayName = "DataRouterState";
var $c700d8a3a13e01e9$export$717f757c655223f1 = $acw62.createContext(false);
function $c700d8a3a13e01e9$var$useIsRSCRouterContext() {
    return $acw62.useContext($c700d8a3a13e01e9$export$717f757c655223f1);
}
var $c700d8a3a13e01e9$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$c700d8a3a13e01e9$export$3681f408decb40d1.displayName = "ViewTransition";
var $c700d8a3a13e01e9$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$c700d8a3a13e01e9$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $c700d8a3a13e01e9$var$AwaitContext = $acw62.createContext(null);
$c700d8a3a13e01e9$var$AwaitContext.displayName = "Await";
var $c700d8a3a13e01e9$export$2666c20e15407622 = (props)=>$acw62.createElement($c700d8a3a13e01e9$var$AwaitContext.Provider, props);
var $c700d8a3a13e01e9$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$c700d8a3a13e01e9$export$3044ab7fdabeaee6.displayName = "Navigation";
var $c700d8a3a13e01e9$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$c700d8a3a13e01e9$export$e6a44b110a0c44d3.displayName = "Location";
var $c700d8a3a13e01e9$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$c700d8a3a13e01e9$export$aac280ed165a4397.displayName = "Route";
var $c700d8a3a13e01e9$var$RouteErrorContext = $acw62.createContext(null);
$c700d8a3a13e01e9$var$RouteErrorContext.displayName = "RouteError";
var $c700d8a3a13e01e9$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $c700d8a3a13e01e9$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $c700d8a3a13e01e9$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $c700d8a3a13e01e9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $c700d8a3a13e01e9$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$c700d8a3a13e01e9$var$ERROR_DIGEST_BASE}:${$c700d8a3a13e01e9$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $c700d8a3a13e01e9$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$c700d8a3a13e01e9$var$ERROR_DIGEST_BASE}:${$c700d8a3a13e01e9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $c700d8a3a13e01e9$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $c700d8a3a13e01e9$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $c700d8a3a13e01e9$export$9c954a9d03d32f4a() {
    return $acw62.useContext($c700d8a3a13e01e9$export$e6a44b110a0c44d3) != null;
}
function $c700d8a3a13e01e9$export$45d76561a5302f2b() {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($c700d8a3a13e01e9$export$e6a44b110a0c44d3).location;
}
function $c700d8a3a13e01e9$export$1b3f31771c5d07c() {
    return $acw62.useContext($c700d8a3a13e01e9$export$e6a44b110a0c44d3).navigationType;
}
function $c700d8a3a13e01e9$export$6c330e8992e8a295(pattern) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$c700d8a3a13e01e9$export$81336c211d5ff295(pattern, $c700d8a3a13e01e9$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $c700d8a3a13e01e9$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $c700d8a3a13e01e9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $c700d8a3a13e01e9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    return isDataRoute ? $c700d8a3a13e01e9$var$useNavigateStable() : $c700d8a3a13e01e9$var$useNavigateUnstable();
}
function $c700d8a3a13e01e9$var$useNavigateUnstable() {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($c700d8a3a13e01e9$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $c700d8a3a13e01e9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $c700d8a3a13e01e9$var$warning(activeRef.current, $c700d8a3a13e01e9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $c700d8a3a13e01e9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $c700d8a3a13e01e9$var$OutletContext = $acw62.createContext(null);
function $c700d8a3a13e01e9$export$4138103a3ae699cc() {
    return $acw62.useContext($c700d8a3a13e01e9$var$OutletContext);
}
function $c700d8a3a13e01e9$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $c700d8a3a13e01e9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($c700d8a3a13e01e9$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$c700d8a3a13e01e9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $c700d8a3a13e01e9$export$5d3fca4a98652595(routes, locationArg) {
    return $c700d8a3a13e01e9$var$useRoutesImpl(routes, locationArg);
}
function $c700d8a3a13e01e9$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $c700d8a3a13e01e9$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $c700d8a3a13e01e9$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
        $c700d8a3a13e01e9$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $c700d8a3a13e01e9$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $c700d8a3a13e01e9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $c700d8a3a13e01e9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $c700d8a3a13e01e9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $c700d8a3a13e01e9$var$DefaultErrorComponent() {
    let error = $c700d8a3a13e01e9$export$ed527bf60f6e05f2();
    let message = $c700d8a3a13e01e9$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $c700d8a3a13e01e9$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$DefaultErrorComponent, null);
var $c700d8a3a13e01e9$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $c700d8a3a13e01e9$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$c700d8a3a13e01e9$var$RenderErrorBoundary.contextType = $c700d8a3a13e01e9$export$717f757c655223f1;
var $c700d8a3a13e01e9$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $c700d8a3a13e01e9$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $c700d8a3a13e01e9$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $c700d8a3a13e01e9$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $c700d8a3a13e01e9$var$parseToInfo(redirect2.location, basename);
            if ($c700d8a3a13e01e9$var$isBrowser && !$c700d8a3a13e01e9$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $c700d8a3a13e01e9$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $c700d8a3a13e01e9$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $c700d8a3a13e01e9$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $c700d8a3a13e01e9$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $c700d8a3a13e01e9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $c700d8a3a13e01e9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $c700d8a3a13e01e9$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    $c700d8a3a13e01e9$export$f5708dca728d7177(ctx, $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $c700d8a3a13e01e9$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    $c700d8a3a13e01e9$export$f5708dca728d7177(state, $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName));
    return state;
}
function $c700d8a3a13e01e9$var$useRouteContext(hookName) {
    let route = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    $c700d8a3a13e01e9$export$f5708dca728d7177(route, $c700d8a3a13e01e9$var$getDataRouterConsoleError(hookName));
    return route;
}
function $c700d8a3a13e01e9$var$useCurrentRouteId(hookName) {
    let route = $c700d8a3a13e01e9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $c700d8a3a13e01e9$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $c700d8a3a13e01e9$var$useRouteId() {
    return $c700d8a3a13e01e9$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $c700d8a3a13e01e9$export$d0fd4b7106de2769() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $c700d8a3a13e01e9$export$600dc272ed516c15() {
    let dataRouterContext = $c700d8a3a13e01e9$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $c700d8a3a13e01e9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $c700d8a3a13e01e9$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$c700d8a3a13e01e9$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $c700d8a3a13e01e9$export$1448a5050d252c4d() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $c700d8a3a13e01e9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $c700d8a3a13e01e9$export$fd5d37484eab868d(routeId) {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $c700d8a3a13e01e9$export$fdc00f3f26066d5e() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $c700d8a3a13e01e9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $c700d8a3a13e01e9$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($c700d8a3a13e01e9$var$RouteErrorContext);
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $c700d8a3a13e01e9$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $c700d8a3a13e01e9$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($c700d8a3a13e01e9$var$AwaitContext);
    return value?._data;
}
function $c700d8a3a13e01e9$export$17f53340677d5831() {
    let value = $acw62.useContext($c700d8a3a13e01e9$var$AwaitContext);
    return value?._error;
}
var $c700d8a3a13e01e9$var$blockerId = 0;
function $c700d8a3a13e01e9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $c700d8a3a13e01e9$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $c700d8a3a13e01e9$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $c700d8a3a13e01e9$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $c700d8a3a13e01e9$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$c700d8a3a13e01e9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $c700d8a3a13e01e9$export$386d57f03f0b2883;
}
function $c700d8a3a13e01e9$var$useNavigateStable() {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $c700d8a3a13e01e9$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $c700d8a3a13e01e9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $c700d8a3a13e01e9$var$warning(activeRef.current, $c700d8a3a13e01e9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $c700d8a3a13e01e9$var$alreadyWarned = {};
function $c700d8a3a13e01e9$var$warningOnce(key, cond, message) {
    if (!cond && !$c700d8a3a13e01e9$var$alreadyWarned[key]) {
        $c700d8a3a13e01e9$var$alreadyWarned[key] = true;
        $c700d8a3a13e01e9$var$warning(false, message);
    }
}
function $c700d8a3a13e01e9$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $c700d8a3a13e01e9$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $c700d8a3a13e01e9$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $c700d8a3a13e01e9$var$alreadyWarned2 = {};
function $c700d8a3a13e01e9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$c700d8a3a13e01e9$var$alreadyWarned2[message]) {
        $c700d8a3a13e01e9$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $c700d8a3a13e01e9$var$USE_OPTIMISTIC = "useOptimistic";
var $c700d8a3a13e01e9$var$useOptimisticImpl = $acw62[$c700d8a3a13e01e9$var$USE_OPTIMISTIC];
var $c700d8a3a13e01e9$var$stableUseOptimisticSetter = ()=>void 0;
function $c700d8a3a13e01e9$var$useOptimisticSafe(val) {
    if ($c700d8a3a13e01e9$var$useOptimisticImpl) return $c700d8a3a13e01e9$var$useOptimisticImpl(val);
    else return [
        val,
        $c700d8a3a13e01e9$var$stableUseOptimisticSetter
    ];
}
function $c700d8a3a13e01e9$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
            if (route.element) $c700d8a3a13e01e9$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $c700d8a3a13e01e9$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($c700d8a3a13e01e9$export$945fecf35a8ef089) {
            if (route.errorElement) $c700d8a3a13e01e9$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $c700d8a3a13e01e9$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $c700d8a3a13e01e9$export$f30f7e456d254e83(routes, opts) {
    return $c700d8a3a13e01e9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $c700d8a3a13e01e9$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $c700d8a3a13e01e9$export$e2fd2c03906469db,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $c700d8a3a13e01e9$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $c700d8a3a13e01e9$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $c700d8a3a13e01e9$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $c700d8a3a13e01e9$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $c700d8a3a13e01e9$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $c700d8a3a13e01e9$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$c700d8a3a13e01e9$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c700d8a3a13e01e9$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$c700d8a3a13e01e9$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $c700d8a3a13e01e9$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $c700d8a3a13e01e9$var$MemoizedDataRoutes = $acw62.memo($c700d8a3a13e01e9$var$DataRoutes);
function $c700d8a3a13e01e9$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $c700d8a3a13e01e9$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $c700d8a3a13e01e9$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $c700d8a3a13e01e9$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $c700d8a3a13e01e9$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $c700d8a3a13e01e9$export$f5708dca728d7177($c700d8a3a13e01e9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    $c700d8a3a13e01e9$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let navigate = $c700d8a3a13e01e9$export$9770f232ac06a008();
    let path = $c700d8a3a13e01e9$var$resolveTo(to, $c700d8a3a13e01e9$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $c700d8a3a13e01e9$export$910ae8079b2c2852(props) {
    return $c700d8a3a13e01e9$export$a3be3530d8e40d0b(props.context);
}
function $c700d8a3a13e01e9$export$e7b0ac011bb776c6(props) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $c700d8a3a13e01e9$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(!$c700d8a3a13e01e9$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $c700d8a3a13e01e9$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $c700d8a3a13e01e9$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $c700d8a3a13e01e9$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $c700d8a3a13e01e9$export$5d3fca4a98652595($c700d8a3a13e01e9$export$16da398f5434bdec(children), location);
}
function $c700d8a3a13e01e9$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $c700d8a3a13e01e9$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$ResolveAwait, null, children));
}
var $c700d8a3a13e01e9$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $c700d8a3a13e01e9$var$ResolveAwait({ children: children }) {
    let data2 = $c700d8a3a13e01e9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $c700d8a3a13e01e9$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $c700d8a3a13e01e9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $c700d8a3a13e01e9$export$f5708dca728d7177(element.type === $c700d8a3a13e01e9$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $c700d8a3a13e01e9$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $c700d8a3a13e01e9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $c700d8a3a13e01e9$export$9b5b6d122dea0c88 = $c700d8a3a13e01e9$export$16da398f5434bdec;
function $c700d8a3a13e01e9$export$daf73786167a7f72(matches) {
    return $c700d8a3a13e01e9$var$_renderMatches(matches);
}
function $c700d8a3a13e01e9$var$useRouteComponentProps() {
    return {
        params: $c700d8a3a13e01e9$export$99eaa27ddbbb95ef(),
        loaderData: $c700d8a3a13e01e9$export$1448a5050d252c4d(),
        actionData: $c700d8a3a13e01e9$export$fdc00f3f26066d5e(),
        matches: $c700d8a3a13e01e9$export$2378eb7f5ff86053()
    };
}
function $c700d8a3a13e01e9$export$6c4f3826290c37af({ children: children }) {
    const props = $c700d8a3a13e01e9$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $c700d8a3a13e01e9$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $c700d8a3a13e01e9$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $c700d8a3a13e01e9$var$useHydrateFallbackProps() {
    return {
        params: $c700d8a3a13e01e9$export$99eaa27ddbbb95ef(),
        loaderData: $c700d8a3a13e01e9$export$1448a5050d252c4d(),
        actionData: $c700d8a3a13e01e9$export$fdc00f3f26066d5e()
    };
}
function $c700d8a3a13e01e9$export$f8cff34f39c1932a({ children: children }) {
    const props = $c700d8a3a13e01e9$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $c700d8a3a13e01e9$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $c700d8a3a13e01e9$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $c700d8a3a13e01e9$var$useErrorBoundaryProps() {
    return {
        params: $c700d8a3a13e01e9$export$99eaa27ddbbb95ef(),
        loaderData: $c700d8a3a13e01e9$export$1448a5050d252c4d(),
        actionData: $c700d8a3a13e01e9$export$fdc00f3f26066d5e(),
        error: $c700d8a3a13e01e9$export$ed527bf60f6e05f2()
    };
}
function $c700d8a3a13e01e9$export$e5afde5c4b6d747b({ children: children }) {
    const props = $c700d8a3a13e01e9$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $c700d8a3a13e01e9$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $c700d8a3a13e01e9$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $c700d8a3a13e01e9$var$defaultMethod = "get";
var $c700d8a3a13e01e9$var$defaultEncType = "application/x-www-form-urlencoded";
function $c700d8a3a13e01e9$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $c700d8a3a13e01e9$var$isButtonElement(object) {
    return $c700d8a3a13e01e9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c700d8a3a13e01e9$var$isFormElement(object) {
    return $c700d8a3a13e01e9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c700d8a3a13e01e9$var$isInputElement(object) {
    return $c700d8a3a13e01e9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c700d8a3a13e01e9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c700d8a3a13e01e9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c700d8a3a13e01e9$var$isModifiedEvent(event);
}
function $c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c700d8a3a13e01e9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $c700d8a3a13e01e9$var$_formDataSupportsSubmitter = null;
function $c700d8a3a13e01e9$var$isFormDataSubmitterSupported() {
    if ($c700d8a3a13e01e9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c700d8a3a13e01e9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c700d8a3a13e01e9$var$_formDataSupportsSubmitter = true;
    }
    return $c700d8a3a13e01e9$var$_formDataSupportsSubmitter;
}
var $c700d8a3a13e01e9$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c700d8a3a13e01e9$var$getFormEncType(encType) {
    if (encType != null && !$c700d8a3a13e01e9$var$supportedFormEncTypes.has(encType)) {
        $c700d8a3a13e01e9$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$c700d8a3a13e01e9$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $c700d8a3a13e01e9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c700d8a3a13e01e9$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $c700d8a3a13e01e9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $c700d8a3a13e01e9$var$defaultMethod;
        encType = $c700d8a3a13e01e9$var$getFormEncType(target.getAttribute("enctype")) || $c700d8a3a13e01e9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c700d8a3a13e01e9$var$isButtonElement(target) || $c700d8a3a13e01e9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $c700d8a3a13e01e9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c700d8a3a13e01e9$var$defaultMethod;
        encType = $c700d8a3a13e01e9$var$getFormEncType(target.getAttribute("formenctype")) || $c700d8a3a13e01e9$var$getFormEncType(form.getAttribute("enctype")) || $c700d8a3a13e01e9$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$c700d8a3a13e01e9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c700d8a3a13e01e9$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $c700d8a3a13e01e9$var$defaultMethod;
        action = null;
        encType = $c700d8a3a13e01e9$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $c700d8a3a13e01e9$var$HOLE = -1;
var $c700d8a3a13e01e9$var$NAN = -2;
var $c700d8a3a13e01e9$var$NEGATIVE_INFINITY = -3;
var $c700d8a3a13e01e9$var$NEGATIVE_ZERO = -4;
var $c700d8a3a13e01e9$var$NULL = -5;
var $c700d8a3a13e01e9$var$POSITIVE_INFINITY = -6;
var $c700d8a3a13e01e9$var$UNDEFINED = -7;
var $c700d8a3a13e01e9$var$TYPE_BIGINT = "B";
var $c700d8a3a13e01e9$var$TYPE_DATE = "D";
var $c700d8a3a13e01e9$var$TYPE_ERROR = "E";
var $c700d8a3a13e01e9$var$TYPE_MAP = "M";
var $c700d8a3a13e01e9$var$TYPE_NULL_OBJECT = "N";
var $c700d8a3a13e01e9$var$TYPE_PROMISE = "P";
var $c700d8a3a13e01e9$var$TYPE_REGEXP = "R";
var $c700d8a3a13e01e9$var$TYPE_SET = "S";
var $c700d8a3a13e01e9$var$TYPE_SYMBOL = "Y";
var $c700d8a3a13e01e9$var$TYPE_URL = "U";
var $c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $c700d8a3a13e01e9$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $c700d8a3a13e01e9$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $c700d8a3a13e01e9$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $c700d8a3a13e01e9$var$UNDEFINED;
    if (input === null) return $c700d8a3a13e01e9$var$NULL;
    if (Number.isNaN(input)) return $c700d8a3a13e01e9$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $c700d8a3a13e01e9$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $c700d8a3a13e01e9$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $c700d8a3a13e01e9$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $c700d8a3a13e01e9$var$stringify.call(this, input, index);
    return index;
}
function $c700d8a3a13e01e9$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$c700d8a3a13e01e9$var$flatten.call(this, k)}":${$c700d8a3a13e01e9$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$c700d8a3a13e01e9$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c700d8a3a13e01e9$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $c700d8a3a13e01e9$var$flatten.call(this, input2[i]) : $c700d8a3a13e01e9$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$c700d8a3a13e01e9$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $c700d8a3a13e01e9$var$flatten.call(this, k),
                                    $c700d8a3a13e01e9$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$c700d8a3a13e01e9$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($c700d8a3a13e01e9$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c700d8a3a13e01e9$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$c700d8a3a13e01e9$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $c700d8a3a13e01e9$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $c700d8a3a13e01e9$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $c700d8a3a13e01e9$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $c700d8a3a13e01e9$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $c700d8a3a13e01e9$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $c700d8a3a13e01e9$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $c700d8a3a13e01e9$var$hydrate.call(this, startIndex);
}
function $c700d8a3a13e01e9$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $c700d8a3a13e01e9$var$UNDEFINED:
                set(void 0);
                continue;
            case $c700d8a3a13e01e9$var$NULL:
                set(null);
                continue;
            case $c700d8a3a13e01e9$var$NAN:
                set(NaN);
                continue;
            case $c700d8a3a13e01e9$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $c700d8a3a13e01e9$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $c700d8a3a13e01e9$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $c700d8a3a13e01e9$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $c700d8a3a13e01e9$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $c700d8a3a13e01e9$var$globalObj && $c700d8a3a13e01e9$var$globalObj[errorType] ? new $c700d8a3a13e01e9$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $c700d8a3a13e01e9$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $c700d8a3a13e01e9$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $c700d8a3a13e01e9$var$Deferred2();
    const reader = readable.pipeThrough($c700d8a3a13e01e9$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $c700d8a3a13e01e9$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $c700d8a3a13e01e9$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $c700d8a3a13e01e9$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $c700d8a3a13e01e9$var$unflatten.call(this, line)
    };
}
async function $c700d8a3a13e01e9$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $c700d8a3a13e01e9$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $c700d8a3a13e01e9$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $c700d8a3a13e01e9$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $c700d8a3a13e01e9$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $c700d8a3a13e01e9$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal, onComplete: onComplete } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $c700d8a3a13e01e9$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $c700d8a3a13e01e9$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_PROMISE}${deferredId}:[["${$c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $c700d8a3a13e01e9$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_ERROR}${deferredId}:[["${$c700d8a3a13e01e9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$c700d8a3a13e01e9$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            onComplete?.();
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $c700d8a3a13e01e9$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $c700d8a3a13e01e9$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $c700d8a3a13e01e9$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $c700d8a3a13e01e9$export$4cf11838cdc2a8a8(html) {
    return html.replace($c700d8a3a13e01e9$var$ESCAPE_REGEX, (match)=>$c700d8a3a13e01e9$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $c700d8a3a13e01e9$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $c700d8a3a13e01e9$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $c700d8a3a13e01e9$var$SingleFetchNoResultError = class extends Error {
};
var $c700d8a3a13e01e9$export$ae9272e641ead836 = 202;
var $c700d8a3a13e01e9$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $c700d8a3a13e01e9$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $c700d8a3a13e01e9$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $c700d8a3a13e01e9$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $c700d8a3a13e01e9$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $c700d8a3a13e01e9$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $c700d8a3a13e01e9$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $c700d8a3a13e01e9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $c700d8a3a13e01e9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $c700d8a3a13e01e9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $c700d8a3a13e01e9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $c700d8a3a13e01e9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $c700d8a3a13e01e9$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($c700d8a3a13e01e9$export$3f1eb41d9a6a6a27(result.result) || $c700d8a3a13e01e9$export$972111febbeef05b(result.result) || $c700d8a3a13e01e9$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $c700d8a3a13e01e9$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $c700d8a3a13e01e9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $c700d8a3a13e01e9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$c700d8a3a13e01e9$var$createDeferred2());
    let singleFetchDfd = $c700d8a3a13e01e9$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $c700d8a3a13e01e9$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $c700d8a3a13e01e9$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $c700d8a3a13e01e9$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $c700d8a3a13e01e9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $c700d8a3a13e01e9$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $c700d8a3a13e01e9$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $c700d8a3a13e01e9$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $c700d8a3a13e01e9$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $c700d8a3a13e01e9$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $c700d8a3a13e01e9$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $c700d8a3a13e01e9$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $c700d8a3a13e01e9$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $c700d8a3a13e01e9$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $c700d8a3a13e01e9$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $c700d8a3a13e01e9$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($c700d8a3a13e01e9$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $c700d8a3a13e01e9$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $c700d8a3a13e01e9$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($c700d8a3a13e01e9$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$c700d8a3a13e01e9$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $c700d8a3a13e01e9$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $c700d8a3a13e01e9$export$4023ad4ecd4126a2(body, global) {
    return $c700d8a3a13e01e9$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $c700d8a3a13e01e9$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$c700d8a3a13e01e9$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $c700d8a3a13e01e9$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $c700d8a3a13e01e9$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $c700d8a3a13e01e9$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $c700d8a3a13e01e9$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $c700d8a3a13e01e9$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $c700d8a3a13e01e9$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $c700d8a3a13e01e9$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $c700d8a3a13e01e9$var$getModuleLinkHrefs(matches, manifest);
    return $c700d8a3a13e01e9$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $c700d8a3a13e01e9$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $c700d8a3a13e01e9$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $c700d8a3a13e01e9$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($c700d8a3a13e01e9$var$prefetchStyleLink));
}
async function $c700d8a3a13e01e9$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$c700d8a3a13e01e9$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$c700d8a3a13e01e9$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$c700d8a3a13e01e9$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($c700d8a3a13e01e9$var$prefetchStyleLink));
}
async function $c700d8a3a13e01e9$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $c700d8a3a13e01e9$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $c700d8a3a13e01e9$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $c700d8a3a13e01e9$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $c700d8a3a13e01e9$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $c700d8a3a13e01e9$var$dedupeLinkDescriptors(links.flat(1).filter($c700d8a3a13e01e9$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $c700d8a3a13e01e9$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $c700d8a3a13e01e9$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $c700d8a3a13e01e9$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $c700d8a3a13e01e9$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $c700d8a3a13e01e9$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $c700d8a3a13e01e9$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$c700d8a3a13e01e9$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($c700d8a3a13e01e9$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $c700d8a3a13e01e9$var$_isPreloadSupported;
function $c700d8a3a13e01e9$var$isPreloadSupported() {
    if ($c700d8a3a13e01e9$var$_isPreloadSupported !== void 0) return $c700d8a3a13e01e9$var$_isPreloadSupported;
    let el = document.createElement("link");
    $c700d8a3a13e01e9$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $c700d8a3a13e01e9$var$_isPreloadSupported;
}
function $c700d8a3a13e01e9$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $c700d8a3a13e01e9$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $c700d8a3a13e01e9$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $c700d8a3a13e01e9$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $c700d8a3a13e01e9$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RemixRootDefaultErrorBoundary, {
            error: $c700d8a3a13e01e9$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $c700d8a3a13e01e9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $c700d8a3a13e01e9$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$c700d8a3a13e01e9$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $c700d8a3a13e01e9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $c700d8a3a13e01e9$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $c700d8a3a13e01e9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $c700d8a3a13e01e9$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $c700d8a3a13e01e9$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $c700d8a3a13e01e9$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $c700d8a3a13e01e9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $c700d8a3a13e01e9$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $c700d8a3a13e01e9$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $c700d8a3a13e01e9$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $c700d8a3a13e01e9$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$c700d8a3a13e01e9$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $c700d8a3a13e01e9$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $c700d8a3a13e01e9$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $c700d8a3a13e01e9$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $c700d8a3a13e01e9$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $c700d8a3a13e01e9$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $c700d8a3a13e01e9$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $c700d8a3a13e01e9$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $c700d8a3a13e01e9$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $c700d8a3a13e01e9$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $c700d8a3a13e01e9$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $c700d8a3a13e01e9$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $c700d8a3a13e01e9$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $c700d8a3a13e01e9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $c700d8a3a13e01e9$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $c700d8a3a13e01e9$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $c700d8a3a13e01e9$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $c700d8a3a13e01e9$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $c700d8a3a13e01e9$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $c700d8a3a13e01e9$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $c700d8a3a13e01e9$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $c700d8a3a13e01e9$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $c700d8a3a13e01e9$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $c700d8a3a13e01e9$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $c700d8a3a13e01e9$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $c700d8a3a13e01e9$var$nextPaths = /* @__PURE__ */ new Set();
var $c700d8a3a13e01e9$var$discoveredPathsMaxSize = 1e3;
var $c700d8a3a13e01e9$var$discoveredPaths = /* @__PURE__ */ new Set();
var $c700d8a3a13e01e9$var$URL_LIMIT = 7680;
function $c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $c700d8a3a13e01e9$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $c700d8a3a13e01e9$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $c700d8a3a13e01e9$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($c700d8a3a13e01e9$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $c700d8a3a13e01e9$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $c700d8a3a13e01e9$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $c700d8a3a13e01e9$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$c700d8a3a13e01e9$var$discoveredPaths.has(pathname)) $c700d8a3a13e01e9$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($c700d8a3a13e01e9$var$nextPaths.keys()).filter((path)=>{
                if ($c700d8a3a13e01e9$var$discoveredPaths.has(path)) {
                    $c700d8a3a13e01e9$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $c700d8a3a13e01e9$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $c700d8a3a13e01e9$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $c700d8a3a13e01e9$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $c700d8a3a13e01e9$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($c700d8a3a13e01e9$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $c700d8a3a13e01e9$var$URL_LIMIT) {
        $c700d8a3a13e01e9$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($c700d8a3a13e01e9$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$c700d8a3a13e01e9$var$addToFifoQueue(p, $c700d8a3a13e01e9$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $c700d8a3a13e01e9$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $c700d8a3a13e01e9$var$addToFifoQueue(path, queue) {
    if (queue.size >= $c700d8a3a13e01e9$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $c700d8a3a13e01e9$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $c700d8a3a13e01e9$var$useDataRouterContext2() {
    let context = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    $c700d8a3a13e01e9$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $c700d8a3a13e01e9$var$useDataRouterStateContext() {
    let context = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    $c700d8a3a13e01e9$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $c700d8a3a13e01e9$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$c700d8a3a13e01e9$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $c700d8a3a13e01e9$var$useFrameworkContext() {
    let context = $acw62.useContext($c700d8a3a13e01e9$export$208d6a3bc3aa62bd);
    $c700d8a3a13e01e9$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $c700d8a3a13e01e9$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($c700d8a3a13e01e9$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $c700d8a3a13e01e9$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $c700d8a3a13e01e9$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $c700d8a3a13e01e9$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $c700d8a3a13e01e9$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $c700d8a3a13e01e9$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $c700d8a3a13e01e9$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $c700d8a3a13e01e9$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$c700d8a3a13e01e9$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $c700d8a3a13e01e9$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $c700d8a3a13e01e9$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let matches = $c700d8a3a13e01e9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$c700d8a3a13e01e9$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$c700d8a3a13e01e9$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$c700d8a3a13e01e9$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $c700d8a3a13e01e9$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$c700d8a3a13e01e9$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $c700d8a3a13e01e9$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $c700d8a3a13e01e9$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $c700d8a3a13e01e9$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { basename: basename } = $c700d8a3a13e01e9$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $c700d8a3a13e01e9$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$c700d8a3a13e01e9$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $c700d8a3a13e01e9$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $c700d8a3a13e01e9$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let _matches = $c700d8a3a13e01e9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$c700d8a3a13e01e9$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $c700d8a3a13e01e9$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $c700d8a3a13e01e9$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $c700d8a3a13e01e9$var$isHydrated = false;
function $c700d8a3a13e01e9$export$3be068dde909e563() {
    $c700d8a3a13e01e9$var$isHydrated = true;
}
function $c700d8a3a13e01e9$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $c700d8a3a13e01e9$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $c700d8a3a13e01e9$var$useDataRouterContext2();
    let { matches: routerMatches } = $c700d8a3a13e01e9$var$useDataRouterStateContext();
    let isRSCRouterContext = $c700d8a3a13e01e9$var$useIsRSCRouterContext();
    let enableFogOfWar = $c700d8a3a13e01e9$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $c700d8a3a13e01e9$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $c700d8a3a13e01e9$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $c700d8a3a13e01e9$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($c700d8a3a13e01e9$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $c700d8a3a13e01e9$var$isHydrated || isRSCRouterContext ? [] : $c700d8a3a13e01e9$var$dedupe(manifest.entry.imports.concat($c700d8a3a13e01e9$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $c700d8a3a13e01e9$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $c700d8a3a13e01e9$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $c700d8a3a13e01e9$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $c700d8a3a13e01e9$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $c700d8a3a13e01e9$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $c700d8a3a13e01e9$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($c700d8a3a13e01e9$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $c700d8a3a13e01e9$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $c700d8a3a13e01e9$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $c700d8a3a13e01e9$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$ff0bf87698939488, null) : null)));
}
var $c700d8a3a13e01e9$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($c700d8a3a13e01e9$var$isBrowser2) window.__reactRouterVersion = "7.13.1";
} catch (e) {}
function $c700d8a3a13e01e9$export$1f3f55432a00e06d(routes, opts) {
    return $c700d8a3a13e01e9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $c700d8a3a13e01e9$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $c700d8a3a13e01e9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e,
        hydrationRouteProperties: $c700d8a3a13e01e9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $c700d8a3a13e01e9$export$1ba7ed8a3a7b3765(routes, opts) {
    return $c700d8a3a13e01e9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $c700d8a3a13e01e9$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $c700d8a3a13e01e9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e,
        hydrationRouteProperties: $c700d8a3a13e01e9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $c700d8a3a13e01e9$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $c700d8a3a13e01e9$var$deserializeErrors(state.errors)
    };
    return state;
}
function $c700d8a3a13e01e9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $c700d8a3a13e01e9$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $c700d8a3a13e01e9$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $c700d8a3a13e01e9$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $c700d8a3a13e01e9$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $c700d8a3a13e01e9$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $c700d8a3a13e01e9$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$c700d8a3a13e01e9$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $c700d8a3a13e01e9$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $c700d8a3a13e01e9$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $c700d8a3a13e01e9$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $c700d8a3a13e01e9$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $c700d8a3a13e01e9$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $c700d8a3a13e01e9$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $c700d8a3a13e01e9$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$c700d8a3a13e01e9$export$a6c7ac8248d6e38a.displayName = "Link";
var $c700d8a3a13e01e9$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c700d8a3a13e01e9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $c700d8a3a13e01e9$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$c700d8a3a13e01e9$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $c700d8a3a13e01e9$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $c700d8a3a13e01e9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let submit = $c700d8a3a13e01e9$export$47c85c6e3a081d3();
    let formAction = $c700d8a3a13e01e9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$c700d8a3a13e01e9$export$a7fed597f4b8afd8.displayName = "Form";
function $c700d8a3a13e01e9$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($c700d8a3a13e01e9$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let matches = $c700d8a3a13e01e9$export$2378eb7f5ff86053();
    $c700d8a3a13e01e9$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $c700d8a3a13e01e9$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$c700d8a3a13e01e9$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $c700d8a3a13e01e9$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $c700d8a3a13e01e9$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($c700d8a3a13e01e9$export$2eeee58951ff3c1c);
    $c700d8a3a13e01e9$export$f5708dca728d7177(ctx, $c700d8a3a13e01e9$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $c700d8a3a13e01e9$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($c700d8a3a13e01e9$export$315e3ffb01f217);
    $c700d8a3a13e01e9$export$f5708dca728d7177(state, $c700d8a3a13e01e9$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $c700d8a3a13e01e9$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $c700d8a3a13e01e9$export$9770f232ac06a008();
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let path = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($c700d8a3a13e01e9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $c700d8a3a13e01e9$export$fe53371bee54353d(location) === $c700d8a3a13e01e9$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $c700d8a3a13e01e9$export$f1a78c17382fe22a(defaultInit) {
    $c700d8a3a13e01e9$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c700d8a3a13e01e9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $c700d8a3a13e01e9$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c700d8a3a13e01e9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $c700d8a3a13e01e9$var$fetcherId = 0;
var $c700d8a3a13e01e9$var$getUniqueFetcherId = ()=>`__${String(++$c700d8a3a13e01e9$var$fetcherId)}__`;
function $c700d8a3a13e01e9$export$47c85c6e3a081d3() {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let currentRouteId = $c700d8a3a13e01e9$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c700d8a3a13e01e9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c700d8a3a13e01e9$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $c700d8a3a13e01e9$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$c700d8a3a13e01e9$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $c700d8a3a13e01e9$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $c700d8a3a13e01e9$export$fe53371bee54353d(path);
}
function $c700d8a3a13e01e9$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $c700d8a3a13e01e9$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($c700d8a3a13e01e9$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($c700d8a3a13e01e9$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $c700d8a3a13e01e9$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $c700d8a3a13e01e9$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $c700d8a3a13e01e9$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $c700d8a3a13e01e9$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $c700d8a3a13e01e9$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $c700d8a3a13e01e9$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $c700d8a3a13e01e9$export$fa996778a3a31087() {
    let state = $c700d8a3a13e01e9$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $c700d8a3a13e01e9$var$savedScrollPositions = {};
function $c700d8a3a13e01e9$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $c700d8a3a13e01e9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $c700d8a3a13e01e9$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $c700d8a3a13e01e9$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c700d8a3a13e01e9$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($c700d8a3a13e01e9$export$3044ab7fdabeaee6);
    let location = $c700d8a3a13e01e9$export$45d76561a5302f2b();
    let matches = $c700d8a3a13e01e9$export$2378eb7f5ff86053();
    let navigation = $c700d8a3a13e01e9$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $c700d8a3a13e01e9$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $c700d8a3a13e01e9$var$getScrollRestorationKey(location, matches, basename, getKey);
            $c700d8a3a13e01e9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c700d8a3a13e01e9$var$savedScrollPositions));
        } catch (error) {
            $c700d8a3a13e01e9$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c700d8a3a13e01e9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c700d8a3a13e01e9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($c700d8a3a13e01e9$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$c700d8a3a13e01e9$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $c700d8a3a13e01e9$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $c700d8a3a13e01e9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $c700d8a3a13e01e9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $c700d8a3a13e01e9$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $c700d8a3a13e01e9$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $c700d8a3a13e01e9$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($c700d8a3a13e01e9$export$3681f408decb40d1);
    $c700d8a3a13e01e9$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $c700d8a3a13e01e9$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $c700d8a3a13e01e9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $c700d8a3a13e01e9$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $c700d8a3a13e01e9$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $c700d8a3a13e01e9$export$81336c211d5ff295(path.pathname, nextPath) != null || $c700d8a3a13e01e9$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $c700d8a3a13e01e9$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $c700d8a3a13e01e9$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $c700d8a3a13e01e9$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $c700d8a3a13e01e9$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $c700d8a3a13e01e9$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $c700d8a3a13e01e9$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $c700d8a3a13e01e9$var$serializeErrors(context.errors)
        };
        let json = $c700d8a3a13e01e9$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($c700d8a3a13e01e9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $c700d8a3a13e01e9$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($c700d8a3a13e01e9$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $c700d8a3a13e01e9$var$getStatelessNavigator() {
    return {
        createHref: $c700d8a3a13e01e9$var$createHref,
        encodeLocation: $c700d8a3a13e01e9$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $c700d8a3a13e01e9$export$69163f0b72ec60d9(routes, opts) {
    return $c700d8a3a13e01e9$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $c700d8a3a13e01e9$export$9269a41d8c4635e
    });
}
function $c700d8a3a13e01e9$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $c700d8a3a13e01e9$export$87cb1a9238dc3fba(routes, $c700d8a3a13e01e9$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $c700d8a3a13e01e9$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $c700d8a3a13e01e9$var$createHref,
        encodeLocation: $c700d8a3a13e01e9$var$encodeLocation,
        getFetcher () {
            return $c700d8a3a13e01e9$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $c700d8a3a13e01e9$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $c700d8a3a13e01e9$var$createHref(to) {
    return typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
}
function $c700d8a3a13e01e9$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $c700d8a3a13e01e9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $c700d8a3a13e01e9$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$1c5a554c78c0cd12 = "@scope";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $298fb931ed4fbf8b$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r);
    });
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$590e8b2c435046d9(e) {
    while(e.root)e = $298fb931ed4fbf8b$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $298fb931ed4fbf8b$export$10d8903dec122b9d(e, e.siblings);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(z += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $298fb931ed4fbf8b$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $298fb931ed4fbf8b$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $298fb931ed4fbf8b$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($298fb931ed4fbf8b$export$9e1725a4cfeada27(b || 1) == 5 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e() || 1) == 5) && $298fb931ed4fbf8b$export$36776f635604f274(z) && $298fb931ed4fbf8b$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($298fb931ed4fbf8b$export$36776f635604f274(z) - l || h === 0 && b === 47)) $298fb931ed4fbf8b$export$10d8903dec122b9d(v > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(j = $298fb931ed4fbf8b$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $298fb931ed4fbf8b$export$98e6a39c04603d36(e, j, j, c && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $298fb931ed4fbf8b$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(z += $298fb931ed4fbf8b$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) z += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    p = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(k = z += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $298fb931ed4fbf8b$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, c, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, c), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(c, n, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(c, n)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$2c0f367103c8d01c + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span", 0) ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(c) - 1 - n > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(c, "stretch", 0) ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(c, n + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(c, $298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$6aad947bda0f3f46:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            if (!$298fb931ed4fbf8b$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                c.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (c.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $298fb931ed4fbf8b$export$590e8b2c435046d9($298fb931ed4fbf8b$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $298fb931ed4fbf8b$export$e6e34fd1f2686227(c, {
                                props: $298fb931ed4fbf8b$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $f8dbcd8598db1f0b$var$a = "data-styled", $f8dbcd8598db1f0b$var$c = "active", $f8dbcd8598db1f0b$var$u = "data-styled-version", $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "6.3.11", $f8dbcd8598db1f0b$var$p = "/*!sc*/\n", $f8dbcd8598db1f0b$var$h = "undefined" != typeof window && "undefined" != typeof document, $f8dbcd8598db1f0b$var$d = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $f8dbcd8598db1f0b$var$f = {}, $f8dbcd8598db1f0b$var$m = {};
function $f8dbcd8598db1f0b$var$y() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $f8dbcd8598db1f0b$var$v(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $f8dbcd8598db1f0b$var$g = 1073741824, $f8dbcd8598db1f0b$var$S = new Map, $f8dbcd8598db1f0b$var$w = new Map, $f8dbcd8598db1f0b$var$b = 1, $f8dbcd8598db1f0b$var$N = function(e) {
    if ($f8dbcd8598db1f0b$var$S.has(e)) return $f8dbcd8598db1f0b$var$S.get(e);
    for(; $f8dbcd8598db1f0b$var$w.has($f8dbcd8598db1f0b$var$b);)$f8dbcd8598db1f0b$var$b++;
    var t = $f8dbcd8598db1f0b$var$b++;
    return $f8dbcd8598db1f0b$var$S.set(e, t), $f8dbcd8598db1f0b$var$w.set(t, e), t;
}, $f8dbcd8598db1f0b$var$E = function(e, t) {
    $f8dbcd8598db1f0b$var$b = t + 1, $f8dbcd8598db1f0b$var$S.set(e, t), $f8dbcd8598db1f0b$var$w.set(t, e);
}, $f8dbcd8598db1f0b$var$C = /invalid hook call/i, $f8dbcd8598db1f0b$var$A = new Set, $f8dbcd8598db1f0b$var$_ = function(t, n) {
    var r, s, i, a, e;
}, $f8dbcd8598db1f0b$var$P = Object.freeze([]), $f8dbcd8598db1f0b$var$I = Object.freeze({});
function $f8dbcd8598db1f0b$var$O(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$I), e.theme !== n.theme && e.theme || t || n.theme;
}
var $f8dbcd8598db1f0b$var$D = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]), $f8dbcd8598db1f0b$var$R = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$T = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$x(e) {
    return e.replace($f8dbcd8598db1f0b$var$R, "-").replace($f8dbcd8598db1f0b$var$T, "");
}
var $f8dbcd8598db1f0b$var$j = /(a)(d)/gi, $f8dbcd8598db1f0b$var$k = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$M(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$k(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$k(t % 52) + n).replace($f8dbcd8598db1f0b$var$j, "$1-$2");
}
var $f8dbcd8598db1f0b$var$V, $f8dbcd8598db1f0b$var$F = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$G = function(e) {
    return $f8dbcd8598db1f0b$var$F(5381, e);
};
function $f8dbcd8598db1f0b$var$L(e) {
    return $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$G(e) >>> 0);
}
function $f8dbcd8598db1f0b$var$B(e) {
    return e.displayName || e.name || "Component";
}
function $f8dbcd8598db1f0b$var$z(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$$ = "function" == typeof Symbol && Symbol.for, $f8dbcd8598db1f0b$var$Y = $f8dbcd8598db1f0b$var$$ ? Symbol.for("react.memo") : 60115, $f8dbcd8598db1f0b$var$W = $f8dbcd8598db1f0b$var$$ ? Symbol.for("react.forward_ref") : 60112, $f8dbcd8598db1f0b$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $f8dbcd8598db1f0b$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $f8dbcd8598db1f0b$var$J = (($f8dbcd8598db1f0b$var$V = {})[$f8dbcd8598db1f0b$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $f8dbcd8598db1f0b$var$V[$f8dbcd8598db1f0b$var$Y] = $f8dbcd8598db1f0b$var$U, $f8dbcd8598db1f0b$var$V);
function $f8dbcd8598db1f0b$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $f8dbcd8598db1f0b$var$Y ? $f8dbcd8598db1f0b$var$U : "$$typeof" in e ? $f8dbcd8598db1f0b$var$J[e.$$typeof] : $f8dbcd8598db1f0b$var$q;
}
var $f8dbcd8598db1f0b$var$Z = Object.defineProperty, $f8dbcd8598db1f0b$var$K = Object.getOwnPropertyNames, $f8dbcd8598db1f0b$var$Q = Object.getOwnPropertySymbols, $f8dbcd8598db1f0b$var$ee = Object.getOwnPropertyDescriptor, $f8dbcd8598db1f0b$var$te = Object.getPrototypeOf, $f8dbcd8598db1f0b$var$ne = Object.prototype;
function $f8dbcd8598db1f0b$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($f8dbcd8598db1f0b$var$ne) {
            var o = $f8dbcd8598db1f0b$var$te(t);
            o && o !== $f8dbcd8598db1f0b$var$ne && $f8dbcd8598db1f0b$var$oe(e, o, n);
        }
        var r = $f8dbcd8598db1f0b$var$K(t);
        $f8dbcd8598db1f0b$var$Q && (r = r.concat($f8dbcd8598db1f0b$var$Q(t)));
        for(var s = $f8dbcd8598db1f0b$var$X(e), i = $f8dbcd8598db1f0b$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $f8dbcd8598db1f0b$var$H || n && n[c] || i && c in i || s && c in s)) {
                var u = $f8dbcd8598db1f0b$var$ee(t, c);
                try {
                    $f8dbcd8598db1f0b$var$Z(e, c, u);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $f8dbcd8598db1f0b$var$re(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $f8dbcd8598db1f0b$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $f8dbcd8598db1f0b$var$ae(e, t) {
    return e.join(t || "");
}
function $f8dbcd8598db1f0b$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $f8dbcd8598db1f0b$var$ue(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$f8dbcd8598db1f0b$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $f8dbcd8598db1f0b$var$ue(e[o], t[o]);
    else if ($f8dbcd8598db1f0b$var$ce(t)) for(var o in t)e[o] = $f8dbcd8598db1f0b$var$ue(e[o], t[o]);
    return e;
}
function $f8dbcd8598db1f0b$var$le(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $f8dbcd8598db1f0b$var$pe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    return e.prototype.indexOfGroup = function(e) {
        if (e === this._cGroup) return this._cIndex;
        var t = this._cIndex;
        if (e > this._cGroup) for(var n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $f8dbcd8598db1f0b$var$v(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = (s = 0, t.length); s < c; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++, a++);
        a > 0 && this._cGroup > e && (this._cIndex += a);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += this.tag.getRule(s) + $f8dbcd8598db1f0b$var$p;
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$he = "style[".concat($f8dbcd8598db1f0b$var$a, "][").concat($f8dbcd8598db1f0b$var$u, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"]'), $f8dbcd8598db1f0b$var$de = new RegExp("^".concat($f8dbcd8598db1f0b$var$a, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $f8dbcd8598db1f0b$var$fe = function(e) {
    return "undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType;
}, $f8dbcd8598db1f0b$var$me = function(e) {
    if (!e) return document;
    if ($f8dbcd8598db1f0b$var$fe(e)) return e;
    if ("getRootNode" in e) {
        var t = e.getRootNode();
        if ($f8dbcd8598db1f0b$var$fe(t)) return t;
    }
    return document;
}, $f8dbcd8598db1f0b$var$ye = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $f8dbcd8598db1f0b$var$ve = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($f8dbcd8598db1f0b$var$p), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($f8dbcd8598db1f0b$var$de);
            if (c) {
                var u = 0 | parseInt(c[1], 10), l = c[2];
                0 !== u && ($f8dbcd8598db1f0b$var$E(l, u), $f8dbcd8598db1f0b$var$ye(e, l, c[3]), e.getTag().insertRules(u, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $f8dbcd8598db1f0b$var$ge = function(e) {
    for(var t = $f8dbcd8598db1f0b$var$me(e.options.target).querySelectorAll($f8dbcd8598db1f0b$var$he), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($f8dbcd8598db1f0b$var$a) !== $f8dbcd8598db1f0b$var$c && ($f8dbcd8598db1f0b$var$ve(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $f8dbcd8598db1f0b$var$Se() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $f8dbcd8598db1f0b$var$we = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($f8dbcd8598db1f0b$var$a, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($f8dbcd8598db1f0b$var$a, $f8dbcd8598db1f0b$var$c), o.setAttribute($f8dbcd8598db1f0b$var$u, $f8dbcd8598db1f0b$export$83d89fbfd8236492);
    var i = $f8dbcd8598db1f0b$var$Se();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $f8dbcd8598db1f0b$var$be = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$we(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            var t;
            if (e.sheet) return e.sheet;
            for(var n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets, o = 0, r = n.length; o < r; o++){
                var s = n[o];
                if (s.ownerNode === e) return s;
            }
            throw $f8dbcd8598db1f0b$var$v(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ne = function() {
    function e(e) {
        this.element = $f8dbcd8598db1f0b$var$we(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ee = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (e === this.length ? this.rules.push(t) : this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$Ce = $f8dbcd8598db1f0b$var$h, $f8dbcd8598db1f0b$var$Ae = {
    isServer: !$f8dbcd8598db1f0b$var$h,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$d
}, $f8dbcd8598db1f0b$var$_e = function() {
    function e(e, n, o) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$I), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $f8dbcd8598db1f0b$var$Ae), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$h && $f8dbcd8598db1f0b$var$Ce && ($f8dbcd8598db1f0b$var$Ce = !1, $f8dbcd8598db1f0b$var$ge(this)), $f8dbcd8598db1f0b$var$le(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $f8dbcd8598db1f0b$var$w.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r);
                    if (void 0 === s || !s.size) return "continue";
                    var i = t.getGroup(n);
                    if (0 === i.length) return "continue";
                    var c = $f8dbcd8598db1f0b$var$a + ".g" + n + '[id="' + r + '"]', u = "";
                    s.forEach(function(e) {
                        e.length > 0 && (u += e + ",");
                    }), o += i + c + '{content:"' + u + '"}' + $f8dbcd8598db1f0b$var$p;
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$N(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $f8dbcd8598db1f0b$var$h && $f8dbcd8598db1f0b$var$ge(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        void 0 === o && (o = !0);
        var r = new e((0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
        return !this.server && $f8dbcd8598db1f0b$var$h && n.target !== this.options.target && $f8dbcd8598db1f0b$var$me(this.options.target) !== $f8dbcd8598db1f0b$var$me(n.target) && $f8dbcd8598db1f0b$var$ge(r), r;
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $f8dbcd8598db1f0b$var$Ee(n) : t ? new $f8dbcd8598db1f0b$var$be(n) : new $f8dbcd8598db1f0b$var$Ne(n);
        }(this.options), new $f8dbcd8598db1f0b$var$pe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        var n, o;
        return null !== (o = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== o && o;
    }, e.prototype.registerName = function(e, t) {
        $f8dbcd8598db1f0b$var$N(e);
        var n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$N(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$N(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $f8dbcd8598db1f0b$var$Pe = /&/g, $f8dbcd8598db1f0b$var$Ie = 47, $f8dbcd8598db1f0b$var$Oe = 42;
function $f8dbcd8598db1f0b$var$De(e) {
    if (-1 === e.indexOf("}")) return !1;
    for(var t = e.length, n = 0, o = 0, r = !1, s = 0; s < t; s++){
        var i = e.charCodeAt(s);
        if (0 !== o || r || i !== $f8dbcd8598db1f0b$var$Ie || e.charCodeAt(s + 1) !== $f8dbcd8598db1f0b$var$Oe) {
            if (r) i === $f8dbcd8598db1f0b$var$Oe && e.charCodeAt(s + 1) === $f8dbcd8598db1f0b$var$Ie && (r = !1, s++);
            else if (34 !== i && 39 !== i || 0 !== s && 92 === e.charCodeAt(s - 1)) {
                if (0 === o) {
                    if (123 === i) n++;
                    else if (125 === i && --n < 0) return !0;
                }
            } else 0 === o ? o = i : o === i && (o = 0);
        } else r = !0, s++;
    }
    return 0 !== n || 0 !== o;
}
function $f8dbcd8598db1f0b$var$Re(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $f8dbcd8598db1f0b$var$Re(e.children, t)), e;
    });
}
function $f8dbcd8598db1f0b$var$Te(e) {
    var t, n, o, r = void 0 === e ? $f8dbcd8598db1f0b$var$I : e, i = r.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$I : i, c = r.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$P : c, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, p = u.slice();
    p.push(function(e) {
        e.type === $298fb931ed4fbf8b$export$aa3a2e812ca8570d && e.value.includes("&") && (o || (o = new RegExp("\\".concat(n, "\\b"), "g")), e.props[0] = e.props[0].replace($f8dbcd8598db1f0b$var$Pe, n).replace(o, l));
    }), a.prefix && p.push($298fb931ed4fbf8b$export$e08c7d021b829b7a), p.push($298fb931ed4fbf8b$export$fac44ee5b035f737);
    var h = [], d = $298fb931ed4fbf8b$export$5a7767152ae0305f(p.concat($298fb931ed4fbf8b$export$38bcb760f1d4871c(function(e) {
        return h.push(e);
    }))), f = function(e, r, i, c) {
        void 0 === r && (r = ""), void 0 === i && (i = ""), void 0 === c && (c = "&"), t = c, n = r, o = void 0;
        var u = function(e) {
            if (!$f8dbcd8598db1f0b$var$De(e)) return e;
            for(var t = e.length, n = "", o = 0, r = 0, s = 0, i = !1, a = 0; a < t; a++){
                var c = e.charCodeAt(a);
                if (0 !== s || i || c !== $f8dbcd8598db1f0b$var$Ie || e.charCodeAt(a + 1) !== $f8dbcd8598db1f0b$var$Oe) {
                    if (i) c === $f8dbcd8598db1f0b$var$Oe && e.charCodeAt(a + 1) === $f8dbcd8598db1f0b$var$Ie && (i = !1, a++);
                    else if (34 !== c && 39 !== c || 0 !== a && 92 === e.charCodeAt(a - 1)) {
                        if (0 === s) {
                            if (123 === c) r++;
                            else if (125 === c) {
                                if (--r < 0) {
                                    for(var u = a + 1; u < t;){
                                        var l = e.charCodeAt(u);
                                        if (59 === l || 10 === l) break;
                                        u++;
                                    }
                                    u < t && 59 === e.charCodeAt(u) && u++, r = 0, a = u - 1, o = u;
                                    continue;
                                }
                                0 === r && (n += e.substring(o, a + 1), o = a + 1);
                            } else 59 === c && 0 === r && (n += e.substring(o, a + 1), o = a + 1);
                        }
                    } else 0 === s ? s = c : s === c && (s = 0);
                } else i = !0, a++;
            }
            if (o < t) {
                var p = e.substring(o);
                $f8dbcd8598db1f0b$var$De(p) || (n += p);
            }
            return n;
        }(function(e) {
            if (-1 === e.indexOf("//")) return e;
            for(var t = e.length, n = [], o = 0, r = 0, s = 0, i = 0; r < t;){
                var a = e.charCodeAt(r);
                if (34 !== a && 39 !== a || 0 !== r && 92 === e.charCodeAt(r - 1)) {
                    if (0 === s) {
                        if (a === $f8dbcd8598db1f0b$var$Ie && r + 1 < t && e.charCodeAt(r + 1) === $f8dbcd8598db1f0b$var$Oe) {
                            for(r += 2; r + 1 < t && (e.charCodeAt(r) !== $f8dbcd8598db1f0b$var$Oe || e.charCodeAt(r + 1) !== $f8dbcd8598db1f0b$var$Ie);)r++;
                            r += 2;
                        } else if (40 === a && r >= 3 && 108 == (32 | e.charCodeAt(r - 1)) && 114 == (32 | e.charCodeAt(r - 2)) && 117 == (32 | e.charCodeAt(r - 3))) i = 1, r++;
                        else if (i > 0) 41 === a ? i-- : 40 === a && i++, r++;
                        else if (a === $f8dbcd8598db1f0b$var$Oe && r + 1 < t && e.charCodeAt(r + 1) === $f8dbcd8598db1f0b$var$Ie) r > o && n.push(e.substring(o, r)), o = r += 2;
                        else if (a === $f8dbcd8598db1f0b$var$Ie && r + 1 < t && e.charCodeAt(r + 1) === $f8dbcd8598db1f0b$var$Ie) {
                            for(r > o && n.push(e.substring(o, r)); r < t && 10 !== e.charCodeAt(r);)r++;
                            o = r;
                        } else r++;
                    } else r++;
                } else 0 === s ? s = a : s === a && (s = 0), r++;
            }
            return 0 === o ? e : (o < t && n.push(e.substring(o)), n.join(""));
        }(e)), l = $298fb931ed4fbf8b$export$ef7acd7185315e22(i || r ? "".concat(i, " ").concat(r, " { ").concat(u, " }") : u);
        return a.namespace && (l = $f8dbcd8598db1f0b$var$Re(l, a.namespace)), h = [], $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(l, d), h;
    };
    return f.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$v(15), $f8dbcd8598db1f0b$var$F(e, t.name);
    }, 5381).toString() : "", f;
}
var $f8dbcd8598db1f0b$var$xe = new $f8dbcd8598db1f0b$var$_e, $f8dbcd8598db1f0b$var$je = $f8dbcd8598db1f0b$var$Te(), $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $f8dbcd8598db1f0b$var$xe,
    stylis: $f8dbcd8598db1f0b$var$je
}), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$Ve = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0);
function $f8dbcd8598db1f0b$var$Fe() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$8c190ef828af4c86);
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo) return e.children;
    var t = $f8dbcd8598db1f0b$var$Fe().styleSheet, n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        var n = t;
        return e.sheet ? n = e.sheet : e.target && (n = n.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (n = n.reconstructWithOptions({
            useCSSOMInjection: !1
        })), n;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        t
    ]), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return $f8dbcd8598db1f0b$var$Te({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: e.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins
    ]), s = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: n,
            stylis: r
        };
    }, [
        e.shouldForwardProp,
        n,
        r
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$Ve.Provider, {
        value: r
    }, e.children));
}
var $f8dbcd8598db1f0b$var$Le = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$je);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $f8dbcd8598db1f0b$var$le(this, function() {
            throw $f8dbcd8598db1f0b$var$v(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$je), this.name + e.hash;
    }, e;
}();
function $f8dbcd8598db1f0b$var$Be(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in (0, $936be3b045ab836e$export$2e2bcd8739ae039) || e.startsWith("--") ? String(t).trim() : "".concat(t, "px");
}
var $f8dbcd8598db1f0b$var$ze = function(e) {
    return e >= "A" && e <= "Z";
};
function $f8dbcd8598db1f0b$var$$e(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $f8dbcd8598db1f0b$var$ze(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $f8dbcd8598db1f0b$var$Ye = function(e) {
    return null == e || !1 === e || "" === e;
}, $f8dbcd8598db1f0b$var$We = function(t) {
    var n = [];
    for(var o in t){
        var r = t[o];
        t.hasOwnProperty(o) && !$f8dbcd8598db1f0b$var$Ye(r) && (Array.isArray(r) && r.isCss || $f8dbcd8598db1f0b$var$re(r) ? n.push("".concat($f8dbcd8598db1f0b$var$$e(o), ":"), r, ";") : $f8dbcd8598db1f0b$var$ce(r) ? n.push.apply(n, (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            "".concat(o, " {")
        ], $f8dbcd8598db1f0b$var$We(r), !1), [
            "}"
        ], !1)) : n.push("".concat($f8dbcd8598db1f0b$var$$e(o), ": ").concat($f8dbcd8598db1f0b$var$Be(o, r), ";")));
    }
    return n;
};
function $f8dbcd8598db1f0b$var$qe(e, t, n, o, r) {
    if (void 0 === r && (r = []), "string" == typeof e) return e && r.push(e), r;
    if ($f8dbcd8598db1f0b$var$Ye(e)) return r;
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return r.push(".".concat(e.styledComponentId)), r;
    if ($f8dbcd8598db1f0b$var$re(e)) {
        if (!$f8dbcd8598db1f0b$var$re(i = e) || i.prototype && i.prototype.isReactComponent || !t) return r.push(e), r;
        var s = e(t);
        return $f8dbcd8598db1f0b$var$qe(s, t, n, o, r);
    }
    var i;
    if (e instanceof $f8dbcd8598db1f0b$var$Le) return n ? (e.inject(n, o), r.push(e.getName(o))) : r.push(e), r;
    if ($f8dbcd8598db1f0b$var$ce(e)) {
        for(var a = $f8dbcd8598db1f0b$var$We(e), c = 0; c < a.length; c++)r.push(a[c]);
        return r;
    }
    if (!Array.isArray(e)) return r.push(e.toString()), r;
    for(c = 0; c < e.length; c++)$f8dbcd8598db1f0b$var$qe(e[c], t, n, o, r);
    return r;
}
function $f8dbcd8598db1f0b$var$He(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$re(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$Ue = $f8dbcd8598db1f0b$var$G($f8dbcd8598db1f0b$export$83d89fbfd8236492), $f8dbcd8598db1f0b$var$Je = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$He(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$F($f8dbcd8598db1f0b$var$Ue, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$_e.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n).className : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $f8dbcd8598db1f0b$var$ie(o, this.staticRulesId);
            else {
                var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$qe(this.rules, e, t, n)), s = $f8dbcd8598db1f0b$var$M($f8dbcd8598db1f0b$var$F(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $f8dbcd8598db1f0b$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $f8dbcd8598db1f0b$var$F(this.baseHash, n.hash), c = "", u = 0; u < this.rules.length; u++){
                var l = this.rules[u];
                if ("string" == typeof l) c += l;
                else if (l) {
                    var p = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$qe(l, e, t, n));
                    a = $f8dbcd8598db1f0b$var$F($f8dbcd8598db1f0b$var$F(a, String(u)), p), c += p;
                }
            }
            if (c) {
                var h = $f8dbcd8598db1f0b$var$M(a >>> 0);
                if (!t.hasNameForId(this.componentId, h)) {
                    var d = n(c, ".".concat(h), void 0, this.componentId);
                    t.insertRules(this.componentId, h, d);
                }
                o = $f8dbcd8598db1f0b$var$ie(o, h);
            }
        }
        return {
            className: o,
            css: "undefined" == typeof window ? t.getTag().getGroup($f8dbcd8598db1f0b$var$N(this.componentId)) : ""
        };
    }, e;
}(), $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(void 0), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$93d4e7f90805808f() {
    var e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6);
    if (!e) throw $f8dbcd8598db1f0b$var$v(18);
    return e;
}
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(function() {
        return function(e, n) {
            if (!e) throw $f8dbcd8598db1f0b$var$v(14);
            if ($f8dbcd8598db1f0b$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $f8dbcd8598db1f0b$var$v(8);
            return n ? (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$et = {}, $f8dbcd8598db1f0b$var$tt = new Set;
function $f8dbcd8598db1f0b$var$nt(e, s, i) {
    var a = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), c = e, u = !$f8dbcd8598db1f0b$var$z(e), p = s.attrs, h = void 0 === p ? $f8dbcd8598db1f0b$var$P : p, d = s.componentId, f = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$x(e);
        $f8dbcd8598db1f0b$var$et[n] = ($f8dbcd8598db1f0b$var$et[n] || 0) + 1;
        var o = "".concat(n, "-").concat($f8dbcd8598db1f0b$var$L($f8dbcd8598db1f0b$export$83d89fbfd8236492 + n + $f8dbcd8598db1f0b$var$et[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(s.displayName, s.parentComponentId) : d, m = s.displayName, y = void 0 === m ? function(e) {
        return $f8dbcd8598db1f0b$var$z(e) ? "styled.".concat(e) : "Styled(".concat($f8dbcd8598db1f0b$var$B(e), ")");
    }(e) : m, v = s.displayName && s.componentId ? "".concat($f8dbcd8598db1f0b$var$x(s.displayName), "-").concat(s.componentId) : s.componentId || f, g = a && c.attrs ? c.attrs.concat(h).filter(Boolean) : h, S = s.shouldForwardProp;
    if (a && c.shouldForwardProp) {
        var w = c.shouldForwardProp;
        if (s.shouldForwardProp) {
            var b = s.shouldForwardProp;
            S = function(e, t) {
                return w(e, t) && b(e, t);
            };
        } else S = w;
    }
    var N = new $f8dbcd8598db1f0b$var$Je(i, v, a ? c.componentStyle : void 0);
    function E(e, s) {
        return function(e, s, i) {
            var a = e.attrs, c = e.componentStyle, u = e.defaultProps, l = e.foldedComponentIds, p = e.styledComponentId, h = e.target, d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), f = $f8dbcd8598db1f0b$var$Fe(), m = e.shouldForwardProp || f.shouldForwardProp;
            var y = $f8dbcd8598db1f0b$var$O(s, d, u) || $f8dbcd8598db1f0b$var$I, v = function(e, n, o) {
                for(var r, s = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $f8dbcd8598db1f0b$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)"className" === c ? s.className = $f8dbcd8598db1f0b$var$ie(s.className, a[c]) : "style" === c ? s.style = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s.style), a[c]) : s[c] = a[c];
                }
                return "className" in n && "string" == typeof n.className && (s.className = $f8dbcd8598db1f0b$var$ie(s.className, n.className)), s;
            }(a, s, y), g = v.as || h, S = {};
            for(var w in v)void 0 === v[w] || "$" === w[0] || "as" === w || "theme" === w && v.theme === y || ("forwardedAs" === w ? S.as = v.forwardedAs : m && !m(w, g) || (S[w] = v[w], m));
            var b = function(e, t) {
                var n = $f8dbcd8598db1f0b$var$Fe(), r = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return r;
            }(c, v), N = b.className;
            var E = $f8dbcd8598db1f0b$var$ie(l, p);
            return N && (E += " " + N), v.className && (E += " " + v.className), S[$f8dbcd8598db1f0b$var$z(g) && !$f8dbcd8598db1f0b$var$D.has(g) ? "class" : "className"] = E, i && (S.ref = i), (0, $acw62.createElement)(g, S);
        }(C, e, s);
    }
    E.displayName = y;
    var C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(E);
    return C.attrs = g, C.componentStyle = N, C.displayName = y, C.shouldForwardProp = S, C.foldedComponentIds = a ? $f8dbcd8598db1f0b$var$ie(c.foldedComponentIds, c.styledComponentId) : "", C.styledComponentId = v, C.target = a ? c.target : e, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = a ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$f8dbcd8598db1f0b$var$ue(e, r[o], !0);
                return e;
            }({}, c.defaultProps, e) : e;
        }
    }), $f8dbcd8598db1f0b$var$le(C, function() {
        return ".".concat(C.styledComponentId);
    }), u && $f8dbcd8598db1f0b$var$oe(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), C;
}
function $f8dbcd8598db1f0b$var$ot(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $f8dbcd8598db1f0b$var$rt = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($f8dbcd8598db1f0b$var$re(t) || $f8dbcd8598db1f0b$var$ce(t)) return $f8dbcd8598db1f0b$var$rt($f8dbcd8598db1f0b$var$qe($f8dbcd8598db1f0b$var$ot($f8dbcd8598db1f0b$var$P, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $f8dbcd8598db1f0b$var$qe(r) : $f8dbcd8598db1f0b$var$rt($f8dbcd8598db1f0b$var$qe($f8dbcd8598db1f0b$var$ot(r, n)));
}
function $f8dbcd8598db1f0b$var$it(n, o, r) {
    if (void 0 === r && (r = $f8dbcd8598db1f0b$var$I), !o) throw $f8dbcd8598db1f0b$var$v(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $f8dbcd8598db1f0b$var$it(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $f8dbcd8598db1f0b$var$it(n, o, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $f8dbcd8598db1f0b$var$at = function(e) {
    return $f8dbcd8598db1f0b$var$it($f8dbcd8598db1f0b$var$nt, e);
}, $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$at;
$f8dbcd8598db1f0b$var$D.forEach(function(e) {
    $f8dbcd8598db1f0b$export$2e2bcd8739ae039[e] = $f8dbcd8598db1f0b$var$at(e);
});
var $f8dbcd8598db1f0b$var$ut = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$He(e), $f8dbcd8598db1f0b$var$_e.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$var$qe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $f8dbcd8598db1f0b$var$_e.registerId(this.componentId + e);
        var r = this.componentId + e;
        this.isStatic ? n.hasNameForId(r, r) || this.createStyles(e, t, n, o) : (this.removeStyles(e, n), this.createStyles(e, t, n, o));
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($f8dbcd8598db1f0b$var$L(JSON.stringify(i))), c = new $f8dbcd8598db1f0b$var$ut(i, a);
    var u = new WeakMap, l = function(e) {
        var t = $f8dbcd8598db1f0b$var$Fe(), n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), r = u.get(t.styleSheet);
        return void 0 === r && (r = t.styleSheet.allocateGSInstance(a), u.set(t.styleSheet, r)), ("undefined" == typeof window || !t.styleSheet.server) && p(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect(function() {
            return t.styleSheet.server || p(r, e, t.styleSheet, n, t.stylis), function() {
                var e;
                c.removeStyles(r, t.styleSheet), e = t.styleSheet.options.target, "undefined" != typeof document && (null != e ? e : document).querySelectorAll('style[data-styled-global="'.concat(a, '"]')).forEach(function(e) {
                    return e.remove();
                });
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function p(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $f8dbcd8598db1f0b$var$f, o, s);
        else {
            var i = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
                theme: $f8dbcd8598db1f0b$var$O(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $f8dbcd8598db1f0b$var$ae($f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $f8dbcd8598db1f0b$var$L(r);
    return new $f8dbcd8598db1f0b$var$Le(s, r);
}
function $f8dbcd8598db1f0b$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(n, r) {
        var s = $f8dbcd8598db1f0b$var$O(n, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($f8dbcd8598db1f0b$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, n), {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($f8dbcd8598db1f0b$var$B(e), ")"), $f8dbcd8598db1f0b$var$oe(n, e);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$Se(), o = $f8dbcd8598db1f0b$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($f8dbcd8598db1f0b$var$a, '="true"'),
                "".concat($f8dbcd8598db1f0b$var$u, '="').concat($f8dbcd8598db1f0b$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $f8dbcd8598db1f0b$var$v(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $f8dbcd8598db1f0b$var$v(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$f8dbcd8598db1f0b$var$a] = "", n[$f8dbcd8598db1f0b$var$u] = $f8dbcd8598db1f0b$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $f8dbcd8598db1f0b$var$Se();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", (0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$_e({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $f8dbcd8598db1f0b$var$v(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $f8dbcd8598db1f0b$var$v(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$_e,
    mainSheet: $f8dbcd8598db1f0b$var$xe
};
var $f8dbcd8598db1f0b$var$mt = "__sc-".concat($f8dbcd8598db1f0b$var$a, "__");




var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");


const $6e9b414d70e3cf7b$var$resolveDefaults = ()=>{
    if (typeof window === "undefined") return {
        REACT_APP_API_BASE_URL: "https://api.laceai.run",
        SHOW_DEBUG_JSON: false
    };
    const host = window.location?.hostname ?? "";
    const isLocalhost = host === "localhost" || host === "127.0.0.1" || host === "::1";
    return {
        REACT_APP_API_BASE_URL: isLocalhost ? "http://localhost:8787" : "https://api.laceai.run",
        SHOW_DEBUG_JSON: isLocalhost
    };
};
const $6e9b414d70e3cf7b$var$defaults = $6e9b414d70e3cf7b$var$resolveDefaults();
const $6e9b414d70e3cf7b$var$runtimeConfig = (typeof window !== "undefined" ? window.__CONFIG__ : null) || {};
const $6e9b414d70e3cf7b$export$e506a1d27d1eaa20 = {
    REACT_APP_API_BASE_URL: $6e9b414d70e3cf7b$var$runtimeConfig.REACT_APP_API_BASE_URL || $6e9b414d70e3cf7b$var$defaults.REACT_APP_API_BASE_URL,
    SHOW_DEBUG_JSON: typeof $6e9b414d70e3cf7b$var$runtimeConfig.SHOW_DEBUG_JSON === "boolean" ? $6e9b414d70e3cf7b$var$runtimeConfig.SHOW_DEBUG_JSON : $6e9b414d70e3cf7b$var$defaults.SHOW_DEBUG_JSON
};




var $acw62 = parcelRequire("acw62");

const $5111a4ba03797b2f$export$c2b96737387ce662 = async ()=>{
    try {
        const response = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/auth/check`, {
            credentials: "include"
        });
        if (response.status === 401 || response.status === 403) return {
            ok: true,
            authenticated: false,
            connected: false,
            admin: false
        };
        if (!response.ok) return {
            ok: false,
            authenticated: false,
            connected: false,
            admin: false,
            error: `Auth check failed (${response.status})`
        };
        const data = await response.json();
        return {
            ok: true,
            // Keep older API/mock responses with connected=true usable while the
            // Workers API rolls out the explicit authenticated field.
            authenticated: Boolean(data?.authenticated ?? data?.connected),
            connected: Boolean(data?.connected),
            admin: Boolean(data?.admin),
            user: data?.user,
            account: data?.account
        };
    } catch  {
        return {
            ok: false,
            authenticated: false,
            connected: false,
            admin: false,
            error: "We couldn't verify your LaceAI session right now. Please check your network and try again."
        };
    }
};


function $57125122a3ba2ea1$var$authReducer(state, action) {
    switch(action.type){
        case "CHECK_SUCCESS":
            return {
                isAuthenticated: action.authenticated,
                isConnected: action.connected,
                isAdmin: action.admin,
                error: null,
                user: action.user,
                account: action.account
            };
        case "CHECK_FAILURE":
            return {
                isAuthenticated: false,
                isConnected: false,
                isAdmin: false,
                error: action.error,
                user: null,
                account: null
            };
        case "RESET":
            return {
                isAuthenticated: false,
                isConnected: false,
                isAdmin: false,
                error: null,
                user: null,
                account: null
            };
        default:
            return state;
    }
}
const $57125122a3ba2ea1$var$initialState = {
    isAuthenticated: false,
    isConnected: false,
    isAdmin: false,
    error: null,
    user: null,
    account: null
};
const $57125122a3ba2ea1$var$actionsCreator = (dispatch)=>({
        checkAuth: async ()=>{
            const result = await (0, $5111a4ba03797b2f$export$c2b96737387ce662)();
            if (!result.ok) {
                dispatch({
                    type: "CHECK_FAILURE",
                    error: result.error || "Unable to verify your LaceAI session."
                });
                return result;
            }
            dispatch({
                type: "CHECK_SUCCESS",
                authenticated: result.authenticated,
                connected: result.connected,
                admin: result.admin,
                user: result.user ?? null,
                account: result.account ?? null
            });
            return result;
        }
    });
const $57125122a3ba2ea1$var$AuthStoreContext = /*#__PURE__*/ (0, $acw62.createContext)({
    state: $57125122a3ba2ea1$var$initialState,
    actions: {}
});
const $57125122a3ba2ea1$export$e1d3eeccb965c5c3 = ({ children: children })=>{
    const [state, dispatch] = (0, $acw62.useReducer)($57125122a3ba2ea1$var$authReducer, $57125122a3ba2ea1$var$initialState);
    const actions = (0, $acw62.useMemo)(()=>$57125122a3ba2ea1$var$actionsCreator(dispatch), [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($57125122a3ba2ea1$var$AuthStoreContext.Provider, {
        value: {
            actions: actions,
            state: state
        },
        children: children
    });
};
function $57125122a3ba2ea1$export$650ce9f0b4df82fd() {
    const ctx = (0, $acw62.useContext)($57125122a3ba2ea1$var$AuthStoreContext);
    if (!ctx) throw new Error("useStore must be used inside a StoreProvider");
    return ctx;
}



const $a51b7a900770e307$export$60332b2344f7fe41 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  background: rgba(241, 245, 249, 0.45);
  border: 1px solid rgba(148, 163, 184, 0.35);
  border-radius: 24px;
  padding: clamp(1.25rem, 2vw, 1.75rem) clamp(1.25rem, 2.5vw, 2rem);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45);
`;
const $a51b7a900770e307$export$7b92b459e668cb21 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a51b7a900770e307$export$60332b2344f7fe41)`
  background: rgba(255, 255, 255, 0.92);
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.25);
`;
const $a51b7a900770e307$export$ac16a6a04d9b7c84 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  --btn-bg: linear-gradient(135deg, #38bdf8, #6366f1);
  border: none;
  border-radius: 999px;
  padding: 0.65rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0f172a;
  background-image: var(--btn-bg);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 20px 30px rgba(79, 70, 229, 0.25);
    filter: brightness(1.03);
  }

  &:disabled {
    cursor: not-allowed;
    background-image: none;
    background-color: rgba(148, 163, 184, 0.45);
    color: rgba(15, 23, 42, 0.45);
    box-shadow: none;
  }
`;
const $a51b7a900770e307$export$f861551692d63a2e = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)($a51b7a900770e307$export$ac16a6a04d9b7c84)`
  background-image: none;
  background-color: rgba(148, 163, 184, 0.2);
  color: #111827;
  border: 1px solid rgba(148, 163, 184, 0.4);

  &:hover:not(:disabled) {
    box-shadow: none;
    background-color: rgba(148, 163, 184, 0.3);
  }
`;
const $a51b7a900770e307$export$f5c9f3c2c4054eec = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).textarea`
  width: 100%;
  min-height: 140px;
  resize: vertical;
  padding: 1rem 1.1rem;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  font-size: 0.95rem;
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  background: rgba(15, 23, 42, 0.02);
  color: #0f172a;
  line-height: 1.6;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: rgba(99, 102, 241, 0.85);
    box-shadow: 0 0 0 4px rgba(129, 140, 248, 0.2);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
const $a51b7a900770e307$export$b04be29aa201d4f5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).label`
  display: block;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.65rem;
  letter-spacing: 0.01em;
`;
const $a51b7a900770e307$export$7bc3de131d90901c = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  font-size: 0.9rem;
  color: #475569;
  margin-top: 0.6rem;
`;
const $a51b7a900770e307$export$44918318b8113b6b = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
`;
const $a51b7a900770e307$export$6088f516e809593c = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  font-size: 0.95rem;
  color: #475569;
  margin: 0;
`;
const $a51b7a900770e307$export$74ac3713b6ac5684 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).pre`
  width: 100%;
  background: #0f172a;
  color: #e2e8f0;
  padding: 1.25rem;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  overflow-x: auto;
  font-size: 0.85rem;
  line-height: 1.6;
  max-height: 420px;
`;
const $a51b7a900770e307$export$7f1bf47c7f50a6aa = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).code`
  font-family: "JetBrains Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  background: rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  padding: 0.15rem 0.35rem;
  font-size: 0.85rem;
`;
const $a51b7a900770e307$export$54c2e3dc7acea9f5 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).ul`
  padding-left: 1.15rem;
  margin: 0.75rem 0 0;
  color: #334155;
  line-height: 1.75;
`;
const $a51b7a900770e307$export$a7b06bfba60a8a78 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).li`
  margin-bottom: 0.35rem;
`;
const $a51b7a900770e307$export$fddf379e22a74b00 = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  padding: 2.5rem 1.75rem;
  border: 1px dashed rgba(148, 163, 184, 0.45);
  border-radius: 20px;
  text-align: center;
  color: #475569;
`;


const $ab4d46d455bbee8a$var$Grid = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.75rem;
`;
const $ab4d46d455bbee8a$var$CardTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
  margin: 0 0 0.75rem;
  font-size: 1.175rem;
  font-weight: 600;
  color: #0f172a;
`;
const $ab4d46d455bbee8a$var$Highlight = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.12);
  color: #1d4ed8;
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.02em;
`;
const $ab4d46d455bbee8a$var$Warning = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  margin-top: 1rem;
  border-radius: 0.85rem;
  border: 1px solid rgba(239, 68, 68, 0.35);
  background: rgba(254, 226, 226, 0.75);
  color: #7f1d1d;
  padding: 0.75rem 0.9rem;
  font-size: 0.92rem;
`;
const $ab4d46d455bbee8a$var$Actions = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;
const $ab4d46d455bbee8a$var$formatIsoDateTime = (value)=>{
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleString();
};
const $ab4d46d455bbee8a$var$ConnectPage = ()=>{
    const { search: search } = (0, $c700d8a3a13e01e9$export$45d76561a5302f2b)();
    const query = new URLSearchParams(search);
    const authError = query.get("authError");
    const garminError = query.get("garminError");
    const loggedOut = query.get("loggedOut") === "true";
    const startSignIn = (path)=>{
        window.location.href = `${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/auth/${path}`;
    };
    const handleConnect = ()=>{
        window.location.href = `${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/auth`;
    };
    const { state: { isAuthenticated: isAuthenticated, isConnected: isConnected, error: error, user: user, account: account } } = (0, $57125122a3ba2ea1$export$650ce9f0b4df82fd)();
    const queryMessage = authError ? ({
        "invalid-state": "Your sign-in session expired. Please try again.",
        cancelled: "Sign-in was cancelled.",
        "login-failed": "We could not complete sign-in. Please try again."
    })[authError] || "We could not complete sign-in. Please try again." : garminError === "already-linked" ? "That Garmin account is already linked to another LaceAI account." : garminError ? "We could not link Garmin. Please try again." : loggedOut ? "You have been signed out." : null;
    const warning = queryMessage || (error && error !== "Not connected" ? error : null);
    if (!isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ab4d46d455bbee8a$var$Grid, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Highlight, {
                        children: "Step 1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$CardTitle, {
                        children: "Create your LaceAI account"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        children: "Create your account, then link one Garmin account to your LaceAI profile."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ab4d46d455bbee8a$var$Actions, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$ac16a6a04d9b7c84), {
                                type: "button",
                                onClick: ()=>startSignIn("register"),
                                children: "Create account"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$f861551692d63a2e), {
                                type: "button",
                                onClick: ()=>startSignIn("login"),
                                children: "Log in"
                            })
                        ]
                    }),
                    warning ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Warning, {
                        children: warning
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Highlight, {
                        children: "What to expect"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$54c2e3dc7acea9f5), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                                children: "Use your LaceAI account to sign in securely"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                                children: "Link Garmin after you return to LaceAI"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                                children: "Your Garmin account is used only for workout sync"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    if (isConnected) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Grid, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                    children: "Connected"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$CardTitle, {
                    children: "Garmin account linked"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                    children: "You can jump straight into generating workouts or browse the library of synced sessions."
                }),
                user?.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                    style: {
                        marginTop: "0.75rem"
                    },
                    children: user.email
                }) : null,
                account ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$54c2e3dc7acea9f5), {
                    style: {
                        marginTop: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                            children: [
                                "Garmin User ID: ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: account.garminUserId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                            children: [
                                "Linked: ",
                                $ab4d46d455bbee8a$var$formatIsoDateTime(account.linkedAt)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                            children: [
                                "Last refreshed: ",
                                $ab4d46d455bbee8a$var$formatIsoDateTime(account.lastUpdatedAt)
                            ]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Actions, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$f861551692d63a2e), {
                        type: "button",
                        onClick: ()=>{
                            window.location.href = `${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/auth/logout`;
                        },
                        children: "Log out"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ab4d46d455bbee8a$var$Grid, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Highlight, {
                        children: "Step 2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$CardTitle, {
                        children: "Link your Garmin account"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        children: "We securely redirect you to Garmin to approve access. LaceAI only requests the scopes required to create workouts on your behalf. One Garmin account can be linked to this LaceAI account."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ab4d46d455bbee8a$var$Actions, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$ac16a6a04d9b7c84), {
                                type: "button",
                                onClick: handleConnect,
                                children: "Connect Garmin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$f861551692d63a2e), {
                                type: "button",
                                onClick: ()=>{
                                    window.location.href = `${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/auth/logout`;
                                },
                                children: "Log out"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$7bc3de131d90901c), {
                        children: "After granting access you\u2019ll land back here automatically."
                    }),
                    warning ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Warning, {
                        children: warning
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab4d46d455bbee8a$var$Highlight, {
                        children: "What to expect"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$54c2e3dc7acea9f5), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                                children: "Read-only access to your basic profile for account linking"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                                children: "Create and push structured workouts directly to Garmin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$a7b06bfba60a8a78), {
                                children: "Revoke access any time from your Garmin account dashboard"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $ab4d46d455bbee8a$export$2e2bcd8739ae039 = $ab4d46d455bbee8a$var$ConnectPage;




var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


parcelRequire("acw62");


parcelRequire("acw62");

const $18ce53a3667d7fa1$var$TargetRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: center;
`;
const $18ce53a3667d7fa1$var$Label = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-weight: 600;
  color: #1f2937;
  font-size: 0.9rem;
`;
const $18ce53a3667d7fa1$var$TargetChip = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(99, 102, 241, 0.16);
  color: #312e81;
  font-size: 0.85rem;
  font-weight: 600;
`;
const $18ce53a3667d7fa1$export$bbfd0888b866f903 = ({ targetType: targetType, targetValue: targetValue, targetValueLow: targetValueLow, targetValueHigh: targetValueHigh })=>{
    if (!targetType || targetType === "OPEN") return null;
    if (targetValue === null || targetValue === undefined) return null;
    const showRange = targetValueLow !== undefined && targetValueHigh !== undefined && targetValueLow !== null && targetValueHigh !== null && targetValueLow !== targetValueHigh;
    const primary = $18ce53a3667d7fa1$var$formatTargetValue(targetType, targetValue);
    const secondary = showRange ? `${$18ce53a3667d7fa1$var$formatTargetValue(targetType, targetValueLow)} \u{2013} ${$18ce53a3667d7fa1$var$formatTargetValue(targetType, targetValueHigh)}` : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($18ce53a3667d7fa1$var$TargetRow, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($18ce53a3667d7fa1$var$Label, {
                children: "Target"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($18ce53a3667d7fa1$var$TargetChip, {
                children: [
                    primary,
                    secondary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: secondary
                    })
                ]
            })
        ]
    });
};
function $18ce53a3667d7fa1$var$formatTargetValue(type, value) {
    const normalized = type.toUpperCase();
    switch(normalized){
        case "PACE":
            return $18ce53a3667d7fa1$var$metresPerSecondToMinutesPerKilometre(value);
        case "PACE_ZONE":
            return `Zone ${Math.round(value)}`;
        case "POWER_GREATER_THAN":
        case "POWER_LESS_THAN":
        case "POWER":
            return `${Math.round(value)} W`;
        case "HEART_RATE":
        case "HEART_RATE_GREATER_THAN":
        case "HEART_RATE_LESS_THAN":
            return `${Math.round(value)} bpm`;
        case "SPEED":
            return `${(value * 3.6).toFixed(1)} km/h`;
        case "CADENCE":
            return `${Math.round(value)} spm`;
        default:
            return value.toString();
    }
}
function $18ce53a3667d7fa1$var$metresPerSecondToMinutesPerKilometre(value) {
    if (value <= 0) return "\u2014";
    const secondsPerKilometre = 1000 / value;
    const minutes = Math.floor(secondsPerKilometre / 60);
    const seconds = Math.round(secondsPerKilometre % 60);
    return `${minutes}:${seconds.toString().padStart(2, "0")}/km`;
}


const $8d5b337087dbd2d7$var$StepContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  border-radius: 20px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(15, 23, 42, 0.03);
  padding: 1.35rem 1.5rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35);
`;
const $8d5b337087dbd2d7$var$StepHeader = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
`;
const $8d5b337087dbd2d7$var$StepBadge = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: rgba(59, 130, 246, 0.18);
  color: #1d4ed8;
`;
const $8d5b337087dbd2d7$var$IntensityPill = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: ${(props)=>props.$bg};
  color: ${(props)=>props.$color};
`;
const $8d5b337087dbd2d7$var$Details = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  color: #475569;
`;
const $8d5b337087dbd2d7$var$DetailRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.9rem;
`;
const $8d5b337087dbd2d7$var$DetailLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-weight: 600;
  color: #1f2937;
`;
const $8d5b337087dbd2d7$var$NestedSteps = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  margin-top: 1.15rem;
  padding-left: 1.1rem;
  display: grid;
  gap: 0.9rem;
  border-left: 2px solid rgba(99, 102, 241, 0.35);
`;
const $8d5b337087dbd2d7$var$MetaChip = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.08);
  font-size: 0.8rem;
  font-weight: 500;
  color: #1f2937;
`;
const $8d5b337087dbd2d7$var$intensityStyles = {
    WARMUP: {
        bg: "rgba(16, 185, 129, 0.15)",
        color: "#0f766e"
    },
    COOLDOWN: {
        bg: "rgba(125, 211, 252, 0.18)",
        color: "#0369a1"
    },
    ACTIVE: {
        bg: "rgba(59, 130, 246, 0.18)",
        color: "#1d4ed8"
    },
    INTERVAL: {
        bg: "rgba(147, 51, 234, 0.18)",
        color: "#6d28d9"
    },
    RECOVERY: {
        bg: "rgba(234, 179, 8, 0.18)",
        color: "#b45309"
    },
    REST: {
        bg: "rgba(148, 163, 184, 0.25)",
        color: "#475569"
    }
};
const $8d5b337087dbd2d7$var$WorkoutStep = ({ step: step })=>{
    const intensityStyle = $8d5b337087dbd2d7$var$intensityStyles[step.intensity] || $8d5b337087dbd2d7$var$intensityStyles.ACTIVE || {
        bg: "rgba(148, 163, 184, 0.2)",
        color: "#334155"
    };
    const durationDisplay = $8d5b337087dbd2d7$var$formatDuration(step.durationType, step.durationValue);
    const repeatSummary = step.type === "WorkoutRepeatStep" ? $8d5b337087dbd2d7$var$formatRepeat(step.repeatType, step.repeatValue, step.steps) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$StepContainer, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$StepHeader, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$StepBadge, {
                        children: [
                            "Step ",
                            step.stepOrder
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$IntensityPill, {
                        $bg: intensityStyle.bg,
                        $color: intensityStyle.color,
                        children: step.intensity || "\u2014"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$Details, {
                children: [
                    step.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$DetailRow, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$DetailLabel, {
                                children: "Description"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: step.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$DetailRow, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$DetailLabel, {
                                children: "Duration"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$MetaChip, {
                                children: durationDisplay
                            })
                        ]
                    }),
                    repeatSummary && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8d5b337087dbd2d7$var$DetailRow, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$DetailLabel, {
                                children: "Repeat"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$MetaChip, {
                                children: repeatSummary
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18ce53a3667d7fa1$export$bbfd0888b866f903), {
                        targetType: step.targetType,
                        targetValue: step.targetValue,
                        targetValueLow: step.targetValueLow,
                        targetValueHigh: step.targetValueHigh
                    })
                ]
            }),
            step.type === "WorkoutRepeatStep" && step.steps && step.steps.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$NestedSteps, {
                children: step.steps.map((nestedStep)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8d5b337087dbd2d7$var$WorkoutStep, {
                        step: nestedStep
                    }, `${step.stepOrder}-${nestedStep.stepOrder}`))
            })
        ]
    });
};
function $8d5b337087dbd2d7$var$formatDuration(type, value) {
    const normalized = type?.toUpperCase?.() ?? "";
    switch(normalized){
        case "TIME":
        case "FIXED_REST":
            {
                const minutes = Math.floor(value / 60);
                const seconds = Math.round(value % 60);
                if (minutes === 0) return `${seconds}s`;
                if (seconds === 0) return `${minutes} min`;
                return `${minutes}m ${seconds}s`;
            }
        case "DISTANCE":
            if (value >= 1000) {
                const kilometres = value / 1000;
                const rounded = Number.isInteger(kilometres) ? kilometres : kilometres.toFixed(2);
                return `${rounded} km`;
            }
            return `${value} m`;
        case "REPS":
            return `${value} reps`;
        case "OPEN":
            return "Open";
        case "CALORIES":
            return `${value} kcal`;
        default:
            return `${value} ${normalized.replace(/_/g, " ").toLowerCase()}`;
    }
}
function $8d5b337087dbd2d7$var$formatRepeat(repeatType, repeatValue, steps) {
    if (!repeatType && !repeatValue) return null;
    const readableType = repeatType ? repeatType.replace("REPEAT_UNTIL_", "").replace(/_/g, " ").toLowerCase() : "repeat";
    if (repeatValue && repeatValue > 0) return `${repeatValue}\xd7 \u{2022} ${readableType}`;
    if (steps && steps.length > 0) return `${steps.length} steps \u{2022} ${readableType}`;
    return readableType;
}
var $8d5b337087dbd2d7$export$2e2bcd8739ae039 = $8d5b337087dbd2d7$var$WorkoutStep;


const $ca872748eef62676$var$WorkoutContainer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
const $ca872748eef62676$var$Header = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).header`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;
const $ca872748eef62676$var$Title = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h3`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
`;
const $ca872748eef62676$var$Description = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0;
  color: #475569;
`;
const $ca872748eef62676$var$Meta = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;
const $ca872748eef62676$var$Steps = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
const $ca872748eef62676$var$Workout = ({ workout: workout })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ca872748eef62676$var$WorkoutContainer, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($ca872748eef62676$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca872748eef62676$var$Meta, {
                        children: workout.sport
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca872748eef62676$var$Title, {
                        children: workout.workoutName
                    }),
                    workout.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca872748eef62676$var$Description, {
                        children: workout.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca872748eef62676$var$Steps, {
                children: workout.steps.map((step)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8d5b337087dbd2d7$export$2e2bcd8739ae039), {
                        step: step
                    }, step.stepOrder))
            })
        ]
    });
};
var $ca872748eef62676$export$2e2bcd8739ae039 = $ca872748eef62676$var$Workout;



const $1774e8bb030c4123$var$Layout = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).section`
  display: grid;
  gap: 2rem;
  grid-template-columns: minmax(0, 1fr);

  @media (min-width: 1080px) {
    grid-template-columns: 1.1fr 0.95fr;
    align-items: start;
  }
`;
const $1774e8bb030c4123$var$Column = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
`;
const $1774e8bb030c4123$var$Actions = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.85rem;
  margin-top: 1.5rem;
`;
const $1774e8bb030c4123$var$StatusText = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 0.9rem;
  color: #334155;
`;
const $1774e8bb030c4123$var$BadgeRow = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
`;
const $1774e8bb030c4123$var$PreviewEmpty = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $a51b7a900770e307$export$6088f516e809593c))`
  padding: 1.75rem 1.25rem;
  border-radius: 18px;
  border: 1px dashed rgba(148, 163, 184, 0.4);
  text-align: center;
`;
const $1774e8bb030c4123$var$GeneratePage = ()=>{
    const [text, setText] = (0, $acw62.useState)("");
    const [statusMsg, setStatusMsg] = (0, $acw62.useState)("");
    const [isUploading, setIsUploading] = (0, $acw62.useState)(false);
    const [isGenerating, setIsGenerating] = (0, $acw62.useState)(false);
    const [workout, setWorkout] = (0, $acw62.useState)(null);
    const { state: { isAuthenticated: isAuthenticated, isConnected: isConnected } } = (0, $57125122a3ba2ea1$export$650ce9f0b4df82fd)();
    const navigate = (0, $c700d8a3a13e01e9$export$9770f232ac06a008)();
    const handleGenerate = async ()=>{
        if (!isAuthenticated) {
            setStatusMsg("Create a LaceAI account before generating workouts.");
            navigate("/connect");
            return;
        }
        setIsGenerating(true);
        setStatusMsg("Generating structured workout...");
        try {
            const res = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/generate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    text: text
                })
            });
            const contentType = res.headers.get("content-type") || "";
            const isJson = contentType.includes("application/json");
            const data = isJson ? await res.json() : null;
            if (!res.ok) {
                const fallbackBody = data ? "" : (await res.text()).trim();
                const errorMessage = data?.error || fallbackBody || `Generation failed (HTTP ${res.status}).`;
                setStatusMsg(errorMessage);
                return;
            }
            if (!data || typeof data !== "object") {
                setStatusMsg("Generation failed: server returned an invalid response.");
                return;
            }
            setWorkout(data);
            setStatusMsg("Workout generated. Review and upload when ready.");
        } catch (e) {
            console.error(e);
            const message = e instanceof Error ? e.message : "Check your connection and API URL, then try again.";
            setStatusMsg(`We hit a snag generating the workout. ${message}`);
        } finally{
            setIsGenerating(false);
        }
    };
    const handleUpload = async ()=>{
        if (!isConnected) {
            setStatusMsg("Link your Garmin account before uploading this workout.");
            navigate("/connect");
            return;
        }
        setIsUploading(true);
        setStatusMsg("Uploading workout to Garmin...");
        try {
            if (!workout) {
                setStatusMsg("Generate a workout before uploading.");
                return;
            }
            const res = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/upload`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify(workout)
            });
            if (!res.ok) {
                const textErr = await res.text();
                throw new Error(textErr);
            }
            setStatusMsg("Upload successful. Check your Garmin calendar to schedule it.");
        } catch (e) {
            console.error(e);
            setStatusMsg("Upload failed. Please try generating the workout again.");
        } finally{
            setIsUploading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1774e8bb030c4123$var$Layout, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1774e8bb030c4123$var$Column, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1774e8bb030c4123$var$BadgeRow, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                                    children: isConnected ? "Garmin connected" : "Ready to generate"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                                    children: isConnected ? "You can generate workouts instantly. Describe your run and LaceAI handles the structured steps." : "Generate and review workouts now. Link Garmin only when you're ready to upload one."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$b04be29aa201d4f5), {
                                        htmlFor: "workout-text",
                                        children: "Describe your workout"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$f5c9f3c2c4054eec), {
                                        id: "workout-text",
                                        value: text,
                                        onChange: (e)=>setText(e.target.value),
                                        placeholder: "15 min warmup, 6x800m @ 3:45/km with 90s jog, 10 min cool down",
                                        disabled: isGenerating
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$7bc3de131d90901c), {
                                        children: [
                                            "Mention reps, recoveries, paces, or zones. You can even nest repeats like",
                                            " ",
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$7f1bf47c7f50a6aa), {
                                                children: "3 x (4 x 200m fast, 200m jog)"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($1774e8bb030c4123$var$Actions, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$ac16a6a04d9b7c84), {
                                        onClick: handleGenerate,
                                        disabled: !text.trim() || isGenerating,
                                        children: isGenerating ? "Generating..." : "Generate Workout"
                                    }),
                                    workout && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$f861551692d63a2e), {
                                        onClick: handleUpload,
                                        disabled: isUploading,
                                        children: isUploading ? "Uploading..." : isConnected ? "Upload to Garmin" : "Connect Garmin to Upload"
                                    }),
                                    statusMsg && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1774e8bb030c4123$var$StatusText, {
                                        children: statusMsg
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1774e8bb030c4123$var$Column, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                    children: workout ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca872748eef62676$export$2e2bcd8739ae039), {
                        workout: workout
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1774e8bb030c4123$var$PreviewEmpty, {
                        children: "Generate a plan to see the breakdown of steps, repeats, and targets exactly as they\u2019ll appear on Garmin."
                    })
                })
            })
        ]
    });
};
var $1774e8bb030c4123$export$2e2bcd8739ae039 = $1774e8bb030c4123$var$GeneratePage;




var $acw62 = parcelRequire("acw62");




const $302f2b3a67f1b730$var$ListCard = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $a51b7a900770e307$export$60332b2344f7fe41))`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;
const $302f2b3a67f1b730$var$Row = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $c700d8a3a13e01e9$export$a6c7ac8248d6e38a))`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border-radius: 18px;
  text-decoration: none;
  color: inherit;
  background: rgba(15, 23, 42, 0.03);
  border: 1px solid transparent;
  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(99, 102, 241, 0.35);
    background: rgba(99, 102, 241, 0.08);
  }
`;
const $302f2b3a67f1b730$var$WorkoutTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  font-weight: 600;
  color: #0f172a;
`;
const $302f2b3a67f1b730$var$WorkoutMeta = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: #475569;
`;
const $302f2b3a67f1b730$var$Timestamp = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  padding: 0.4rem 0.75rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.06);
  font-size: 0.8rem;
  font-weight: 500;
`;
const $302f2b3a67f1b730$var$Header = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
`;
const $302f2b3a67f1b730$var$SyncButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  border: 1px solid rgba(99, 102, 241, 0.45);
  background: rgba(99, 102, 241, 0.1);
  color: #3730a3;
  font-weight: 600;
  border-radius: 999px;
  padding: 0.5rem 1rem;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
const $302f2b3a67f1b730$var$WorkoutsPage = ()=>{
    const [workouts, setWorkouts] = (0, $acw62.useState)([]);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)("");
    const [isSyncing, setIsSyncing] = (0, $acw62.useState)(false);
    const loadWorkouts = (0, $acw62.useCallback)(()=>{
        setLoading(true);
        fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/workouts`, {
            credentials: "include"
        }).then(async (res)=>{
            if (!res.ok) throw new Error(`Failed to load workouts (${res.status})`);
            return res.json();
        }).then((data)=>{
            setWorkouts(Array.isArray(data.workouts) ? data.workouts : []);
            setError("");
            setLoading(false);
        }).catch((err)=>{
            console.error(err);
            setError("Could not load workouts. Please check your network and retry.");
            setLoading(false);
        });
    }, []);
    const syncWorkouts = (0, $acw62.useCallback)(()=>{
        setIsSyncing(true);
        fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/workouts/sync`, {
            method: "POST",
            credentials: "include"
        }).then(async (res)=>{
            if (!res.ok) {
                const body = await res.json().catch(()=>({}));
                const message = typeof body.error === "string" ? body.error : `Failed to sync workouts (${res.status})`;
                throw new Error(message);
            }
            return res.json();
        }).then(()=>{
            setError("");
            loadWorkouts();
        }).catch((err)=>{
            console.error(err);
            setError("Could not sync workouts from Garmin right now. Please try again.");
        }).finally(()=>setIsSyncing(false));
    }, [
        loadWorkouts
    ]);
    (0, $acw62.useEffect)(()=>{
        loadWorkouts();
    }, [
        loadWorkouts
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                children: "Loading"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                children: "Pulling your recent workouts from Garmin..."
            })
        ]
    });
    if (workouts.length === 0) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($302f2b3a67f1b730$var$Header, {
                children: [
                    error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                        children: "Error"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                        children: "Empty"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($302f2b3a67f1b730$var$SyncButton, {
                        type: "button",
                        onClick: syncWorkouts,
                        disabled: isSyncing,
                        children: isSyncing ? "Syncing..." : "Sync Garmin Workouts"
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$fddf379e22a74b00), {
                children: error
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$fddf379e22a74b00), {
                children: "No workouts yet. Generate a new session and it will appear here as soon as it\u2019s pushed to Garmin."
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($302f2b3a67f1b730$var$ListCard, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($302f2b3a67f1b730$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                                children: "Recent"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                                style: {
                                    marginTop: "0.45rem"
                                },
                                children: "Drill into earlier workouts to confirm the structure before you run."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($302f2b3a67f1b730$var$SyncButton, {
                        type: "button",
                        onClick: syncWorkouts,
                        disabled: isSyncing,
                        children: isSyncing ? "Syncing..." : "Sync Garmin Workouts"
                    })
                ]
            }),
            workouts.map((w)=>{
                const created = typeof w.createdAt === "string" ? new Date(w.createdAt) : new Date(w.createdAt._seconds * 1000);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($302f2b3a67f1b730$var$Row, {
                    to: `/workouts/${w.workoutId}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($302f2b3a67f1b730$var$WorkoutTitle, {
                                    children: w.name || "Untitled workout"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($302f2b3a67f1b730$var$WorkoutMeta, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "ID: ",
                                                w.workoutId
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            children: [
                                                "Owner: ",
                                                w.ownerId
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($302f2b3a67f1b730$var$Timestamp, {
                            children: created.toLocaleString()
                        })
                    ]
                }, w.workoutId);
            })
        ]
    });
};
var $302f2b3a67f1b730$export$2e2bcd8739ae039 = $302f2b3a67f1b730$var$WorkoutsPage;




var $acw62 = parcelRequire("acw62");





const $fdab0ffcc0242844$var$Header = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;
const $fdab0ffcc0242844$var$BackLink = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $c700d8a3a13e01e9$export$a6c7ac8248d6e38a))`
  color: #2563eb;
  font-weight: 600;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`;
const $fdab0ffcc0242844$var$ErrorText = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  color: #dc2626;
  font-weight: 600;
`;
const $fdab0ffcc0242844$var$Hero = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $a51b7a900770e307$export$7b92b459e668cb21))`
  margin-top: 1.5rem;
  display: grid;
  gap: 1rem;
`;
const $fdab0ffcc0242844$var$HeroTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h2`
  margin: 0;
  font-size: clamp(1.35rem, 2.8vw, 1.75rem);
  color: #0f172a;
`;
const $fdab0ffcc0242844$var$InfoGrid = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.8rem;
`;
const $fdab0ffcc0242844$var$InfoCard = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  border-radius: 16px;
  padding: 0.85rem 0.95rem;
  background: rgba(15, 23, 42, 0.04);
  border: 1px solid rgba(148, 163, 184, 0.26);
`;
const $fdab0ffcc0242844$var$Label = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0;
  color: #64748b;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;
const $fdab0ffcc0242844$var$Value = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0.35rem 0 0;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 600;
`;
const $fdab0ffcc0242844$var$WorkoutSection = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $a51b7a900770e307$export$7b92b459e668cb21))`
  margin-top: 1rem;
`;
const $fdab0ffcc0242844$var$WorkoutDetailPage = ()=>{
    const { id: id } = (0, $c700d8a3a13e01e9$export$99eaa27ddbbb95ef)();
    const [workout, setWorkout] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        if (!id) return;
        fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/workouts/${id}`, {
            credentials: "include"
        }).then((res)=>{
            if (!res.ok) throw new Error(`Status ${res.status}`);
            return res.json();
        }).then((data)=>{
            setWorkout(data.workout ?? null);
            setLoading(false);
        }).catch((err)=>{
            console.error(err);
            setError("Failed to load workout.");
            setLoading(false);
        });
    }, [
        id
    ]);
    const summary = (0, $acw62.useMemo)(()=>{
        const steps = workout?.payload?.steps ?? [];
        return {
            stepCount: $fdab0ffcc0242844$var$countAllSteps(steps),
            repeats: $fdab0ffcc0242844$var$countRepeats(steps),
            estimatedDuration: $fdab0ffcc0242844$var$formatSeconds($fdab0ffcc0242844$var$sumDurationInSeconds(steps)),
            lastUpdated: $fdab0ffcc0242844$var$formatApiDate(workout?.createdAt)
        };
    }, [
        workout
    ]);
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                children: "Loading"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                children: "Retrieving workout details..."
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                children: "Error"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$ErrorText, {
                children: error
            })
        ]
    });
    if (!workout) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                children: "Missing"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                children: "No workout found for this ID."
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                        children: "Workout details"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        children: "A runner-friendly overview of your session, so you can quickly understand what to expect before you head out."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$BackLink, {
                        to: "/workouts",
                        children: "\u2190 Back to workouts"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$Hero, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$HeroTitle, {
                        children: workout.payload?.workoutName || workout.name || "Untitled workout"
                    }),
                    workout.payload?.description && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        children: workout.payload.description
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$InfoGrid, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$InfoCard, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Label, {
                                        children: "Sport"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Value, {
                                        children: workout.payload?.sport || "Run"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$InfoCard, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Label, {
                                        children: "Total steps"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Value, {
                                        children: summary.stepCount
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$InfoCard, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Label, {
                                        children: "Repeat blocks"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Value, {
                                        children: summary.repeats
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$InfoCard, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Label, {
                                        children: "Estimated moving time"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Value, {
                                        children: summary.estimatedDuration
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fdab0ffcc0242844$var$InfoCard, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Label, {
                                        children: "Added to library"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$Value, {
                                        children: summary.lastUpdated
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($fdab0ffcc0242844$var$WorkoutSection, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca872748eef62676$export$2e2bcd8739ae039), {
                    workout: workout.payload
                })
            })
        ]
    });
};
function $fdab0ffcc0242844$var$countAllSteps(steps) {
    return steps.reduce((acc, step)=>{
        const nested = step.steps ? $fdab0ffcc0242844$var$countAllSteps(step.steps) : 0;
        return acc + 1 + nested;
    }, 0);
}
function $fdab0ffcc0242844$var$countRepeats(steps) {
    return steps.reduce((acc, step)=>{
        const nested = step.steps ? $fdab0ffcc0242844$var$countRepeats(step.steps) : 0;
        const isRepeat = step.type === "WorkoutRepeatStep" ? 1 : 0;
        return acc + isRepeat + nested;
    }, 0);
}
function $fdab0ffcc0242844$var$sumDurationInSeconds(steps) {
    return steps.reduce((acc, step)=>{
        const nested = step.steps ? $fdab0ffcc0242844$var$sumDurationInSeconds(step.steps) : 0;
        const type = step.durationType?.toUpperCase();
        const estimated = type === "TIME" || type === "FIXED_REST" ? Number(step.durationValue || 0) : 0;
        return acc + nested + estimated;
    }, 0);
}
function $fdab0ffcc0242844$var$formatSeconds(totalSeconds) {
    if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return "Not available";
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor(totalSeconds % 3600 / 60);
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes} min`;
}
function $fdab0ffcc0242844$var$formatApiDate(value) {
    if (!value) return "Unknown";
    const date = typeof value === "string" ? new Date(value) : new Date(value._seconds * 1000);
    if (Number.isNaN(date.getTime())) return "Unknown";
    return date.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric"
    });
}
var $fdab0ffcc0242844$export$2e2bcd8739ae039 = $fdab0ffcc0242844$var$WorkoutDetailPage;




var $acw62 = parcelRequire("acw62");




const $871411710519ddd4$var$Grid = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 1rem;
`;
const $871411710519ddd4$var$Stat = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
`;
const $871411710519ddd4$var$Big = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).span`
  font-size: 2rem;
  font-weight: 700;
`;
const $871411710519ddd4$var$AdminCard = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $a51b7a900770e307$export$60332b2344f7fe41))`
  margin-top: 0.25rem;
`;
const $871411710519ddd4$var$AdminForm = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).form`
  display: grid;
  gap: 1rem;
  margin-top: 1rem;

  @media (min-width: 720px) {
    grid-template-columns: minmax(0, 1fr) minmax(120px, 0.25fr) auto;
    align-items: end;
  }
`;
const $871411710519ddd4$var$Field = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 0.45rem;
`;
const $871411710519ddd4$var$FieldLabel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).label`
  font-size: 0.85rem;
  font-weight: 600;
  color: #344054;
`;
const $871411710519ddd4$var$Input = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).input`
  min-width: 0;
  padding: 0.7rem 0.8rem;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  color: #172033;
  background: #ffffff;

  &:focus {
    outline: none;
    border-color: #315fd6;
    box-shadow: 0 0 0 3px rgba(49, 95, 214, 0.12);
  }
`;
function $871411710519ddd4$var$formatBillingDate(value) {
    const date = typeof value === "string" ? new Date(value) : new Date(value._seconds * 1000);
    if (Number.isNaN(date.getTime())) return "Unknown";
    return date.toLocaleDateString();
}
const $871411710519ddd4$var$BillingPage = ()=>{
    const { state: { isAdmin: isAdmin, user: user } } = (0, $57125122a3ba2ea1$export$650ce9f0b4df82fd)();
    const [billing, setBilling] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(true);
    const [status, setStatus] = (0, $acw62.useState)("");
    const [adminEmail, setAdminEmail] = (0, $acw62.useState)("");
    const [adminAmount, setAdminAmount] = (0, $acw62.useState)("10");
    const [adminStatus, setAdminStatus] = (0, $acw62.useState)("");
    const [isGranting, setIsGranting] = (0, $acw62.useState)(false);
    const load = async ()=>{
        setLoading(true);
        try {
            const res = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/billing/summary`, {
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Failed to load billing (${res.status})`);
            const data = await res.json();
            setBilling(data.billing);
            setStatus("");
        } finally{
            setLoading(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        load().catch((e)=>{
            console.error(e);
            setStatus("Could not load billing profile.");
            setLoading(false);
        });
    }, []);
    const startCheckout = async ()=>{
        try {
            const res = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/billing/checkout`, {
                method: "POST",
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Checkout start failed (${res.status})`);
            const data = await res.json();
            if (data.checkoutUrl) {
                window.location.href = data.checkoutUrl;
                return;
            }
            setStatus("Checkout link was unavailable. Please try again.");
        } catch (e) {
            console.error(e);
            setStatus("Could not start checkout. Please try again.");
        }
    };
    const openPortal = async ()=>{
        try {
            const res = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/billing/portal`, {
                method: "POST",
                credentials: "include"
            });
            if (!res.ok) throw new Error(`Portal open failed (${res.status})`);
            const data = await res.json();
            if (data.portalUrl) {
                window.location.href = data.portalUrl;
                return;
            }
            setStatus("Billing portal link was unavailable. Please try again.");
        } catch (e) {
            console.error(e);
            setStatus("Could not open billing portal. Please try again.");
        }
    };
    const grantCredits = async (event)=>{
        event.preventDefault();
        const amount = Number(adminAmount);
        if (!Number.isInteger(amount) || amount < 1 || amount > 10000) {
            setAdminStatus("Enter a whole number of credits from 1 to 10,000.");
            return;
        }
        setIsGranting(true);
        setAdminStatus("Granting complimentary credits...");
        try {
            const res = await fetch(`${(0, $6e9b414d70e3cf7b$export$e506a1d27d1eaa20).REACT_APP_API_BASE_URL}/admin/credits`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    email: adminEmail,
                    amount: amount
                })
            });
            const data = await res.json().catch(()=>null);
            if (!res.ok) {
                setAdminStatus(data?.error || `Credit grant failed (${res.status}).`);
                return;
            }
            setAdminStatus(`Granted ${data.granted} credits to ${data.target.email}. Complimentary balance: ${data.complimentaryTokenBalance}.`);
            if (adminEmail.trim().toLowerCase() === user?.email?.trim().toLowerCase()) await load();
        } catch (error) {
            console.error(error);
            setAdminStatus("Could not grant credits. Please try again.");
        } finally{
            setIsGranting(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                children: "Loading"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                children: "Fetching billing details..."
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($871411710519ddd4$var$Grid, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                        children: billing?.subscriptionStatus || "inactive"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        style: {
                            marginTop: "0.65rem"
                        },
                        children: "Tokens refresh every billing cycle. Each workout generation costs 1 token."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($871411710519ddd4$var$Stat, {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($871411710519ddd4$var$Big, {
                                children: billing?.tokenBalance ?? 0
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "tokens remaining"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        children: [
                            "Used ",
                            billing?.tokensUsedThisPeriod ?? 0,
                            " / ",
                            billing?.monthlyTokenAllowance ?? 0,
                            " this period."
                        ]
                    }),
                    (billing?.complimentaryTokenBalance ?? 0) > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        style: {
                            marginTop: "0.45rem"
                        },
                        children: [
                            billing?.complimentaryTokenBalance,
                            " complimentary + ",
                            billing?.subscriptionTokenBalance ?? 0,
                            " subscription credits"
                        ]
                    }),
                    billing?.currentPeriodEnd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        children: [
                            "Renews on ",
                            $871411710519ddd4$var$formatBillingDate(billing.currentPeriodEnd),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a51b7a900770e307$export$60332b2344f7fe41), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            gap: "0.8rem",
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$ac16a6a04d9b7c84), {
                                onClick: startCheckout,
                                children: "Start monthly plan"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$f861551692d63a2e), {
                                onClick: openPortal,
                                children: "Manage subscription"
                            })
                        ]
                    }),
                    status && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        style: {
                            marginTop: "0.8rem"
                        },
                        children: status
                    })
                ]
            }),
            isAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($871411710519ddd4$var$AdminCard, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$44918318b8113b6b), {
                        children: "Admin"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        style: {
                            marginTop: "0.65rem"
                        },
                        children: "Grant complimentary generation credits to a registered LaceAI user. This does not change their Stripe subscription."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($871411710519ddd4$var$AdminForm, {
                        onSubmit: grantCredits,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($871411710519ddd4$var$Field, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($871411710519ddd4$var$FieldLabel, {
                                        htmlFor: "admin-credit-email",
                                        children: "User email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($871411710519ddd4$var$Input, {
                                        id: "admin-credit-email",
                                        type: "email",
                                        value: adminEmail,
                                        onChange: (event)=>setAdminEmail(event.target.value),
                                        placeholder: "runner@example.com",
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($871411710519ddd4$var$Field, {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($871411710519ddd4$var$FieldLabel, {
                                        htmlFor: "admin-credit-amount",
                                        children: "Credits"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($871411710519ddd4$var$Input, {
                                        id: "admin-credit-amount",
                                        type: "number",
                                        min: "1",
                                        max: "10000",
                                        step: "1",
                                        value: adminAmount,
                                        onChange: (event)=>setAdminAmount(event.target.value),
                                        required: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$ac16a6a04d9b7c84), {
                                type: "submit",
                                disabled: isGranting,
                                children: isGranting ? "Granting..." : "Grant Credits"
                            })
                        ]
                    }),
                    adminStatus && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                        style: {
                            marginTop: "0.8rem"
                        },
                        children: adminStatus
                    })
                ]
            })
        ]
    });
};
var $871411710519ddd4$export$2e2bcd8739ae039 = $871411710519ddd4$var$BillingPage;



parcelRequire("acw62");



const $28a84c939a5ce9f4$var$NotFoundCard = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $a51b7a900770e307$export$60332b2344f7fe41))`
  display: grid;
  gap: 0.85rem;
`;
const $28a84c939a5ce9f4$var$BackLink = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $c700d8a3a13e01e9$export$a6c7ac8248d6e38a))`
  width: fit-content;
  color: #2563eb;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
const $28a84c939a5ce9f4$var$NotFoundPage = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($28a84c939a5ce9f4$var$NotFoundCard, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a51b7a900770e307$export$6088f516e809593c), {
                children: "We couldn\u2019t find that LaceAI page. Check the address or return to your workout workspace."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($28a84c939a5ce9f4$var$BackLink, {
                to: "/generate",
                children: "Go to Generate"
            })
        ]
    });
var $28a84c939a5ce9f4$export$2e2bcd8739ae039 = $28a84c939a5ce9f4$var$NotFoundPage;



var $14264e82b17c5b1e$exports = {};
$14264e82b17c5b1e$exports = import.meta.resolve("2P3jp");


const $19482cc54da0537f$var$brandLogoUrl = new URL($14264e82b17c5b1e$exports).toString();
const $19482cc54da0537f$var$GlobalStyle = (0, $f8dbcd8598db1f0b$export$f0f03736edb61697)`
  :root {
    color-scheme: light;
  }

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    background: radial-gradient(circle at 0% 0%, rgba(59, 130, 246, 0.15), transparent 45%),
      radial-gradient(circle at 100% 20%, rgba(236, 72, 153, 0.15), transparent 40%),
      #0f172a;
    color: #0f172a;
    min-height: 100vh;
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;
const $19482cc54da0537f$var$Chrome = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
const $19482cc54da0537f$var$Header = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).header`
  position: sticky;
  top: 0;
  z-index: 10;
  backdrop-filter: blur(12px);
  background: rgba(15, 23, 42, 0.6);
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
`;
const $19482cc54da0537f$var$NavBar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).nav`
  max-width: 1120px;
  margin: 0 auto;
  padding: 1.1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 0.85rem;
    padding: 0.9rem 1rem;
  }
`;
const $19482cc54da0537f$var$Brand = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $c700d8a3a13e01e9$export$b0d92dbee9b5b60d))`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  color: #e2e8f0;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  font-size: 0.95rem;
  text-decoration: none;
`;
const $19482cc54da0537f$var$BrandLogo = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img`
  display: block;
  width: 118px;
  height: 58px;
  object-fit: cover;
  object-position: center;
`;
const $19482cc54da0537f$var$DesktopNavLinks = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 0.5rem;

  @media (max-width: 768px) {
    display: none;
  }
`;
const $19482cc54da0537f$var$MobileNavLinks = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.4rem;
`;
const $19482cc54da0537f$var$MobileMenuButton = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).button`
  display: none;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: rgba(148, 163, 184, 0.2);
  color: #e2e8f0;
  border-radius: 12px;
  padding: 0.45rem 0.75rem;
  font-weight: 600;
  font-size: 0.86rem;

  @media (max-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
const $19482cc54da0537f$var$MobileOnlyNavLinks = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: 100%;
  display: none;

  @media (max-width: 768px) {
    display: ${({ $open: $open })=>$open ? "block" : "none"};
  }
`;
const $19482cc54da0537f$var$StyledLink = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039)((0, $c700d8a3a13e01e9$export$b0d92dbee9b5b60d))`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.55rem 1.1rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #cbd5f5;
  text-decoration: none;
  background: rgba(148, 163, 184, 0.12);
  border: 1px solid transparent;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(148, 163, 184, 0.22);
    border-color: rgba(148, 163, 184, 0.35);
  }

  &.active {
    color: #0b1220;
    background: linear-gradient(135deg, #38bdf8, #818cf8);
    border-color: transparent;
    box-shadow: 0 10px 30px rgba(79, 70, 229, 0.28);
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
const $19482cc54da0537f$var$Main = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).main`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 3.5rem 1.5rem 4.5rem;

  @media (max-width: 768px) {
    padding: 1rem 0 2rem;
  }
`;
const $19482cc54da0537f$var$ContentPanel = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  width: 100%;
  max-width: 1100px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 2.5rem;
`;
const $19482cc54da0537f$var$PageSurface = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).section`
  background: rgba(255, 255, 255, 0.92);
  border-radius: 28px;
  padding: 2.75rem clamp(1.5rem, 3vw, 3rem);
  box-shadow:
    0 30px 60px -20px rgba(15, 23, 42, 0.45),
    inset 0 1px 0 rgba(148, 163, 184, 0.15);
  border: 1px solid rgba(148, 163, 184, 0.18);

  @media (max-width: 768px) {
    border-radius: 0;
    border-left: none;
    border-right: none;
    padding: 1.5rem 1rem;
  }
`;
const $19482cc54da0537f$var$SectionTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h1`
  margin: 0 0 0.75rem;
  font-size: clamp(1.75rem, 3vw, 2.35rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
`;
const $19482cc54da0537f$var$SectionSubTitle = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0;
  font-size: 1rem;
  color: #475569;
  max-width: 48ch;
`;
const $19482cc54da0537f$var$PageHeader = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).header`
  margin-bottom: 2.25rem;
`;
const $19482cc54da0537f$var$App = ()=>{
    const { pathname: pathname } = (0, $c700d8a3a13e01e9$export$45d76561a5302f2b)();
    const { state: { isAuthenticated: isAuthenticated, isConnected: isConnected } } = (0, $57125122a3ba2ea1$export$650ce9f0b4df82fd)();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const shouldShowNavigation = isAuthenticated;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setIsMobileMenuOpen(false);
    }, [
        pathname
    ]);
    if (!isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$GlobalStyle, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$Chrome, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$Main, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$ContentPanel, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c700d8a3a13e01e9$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                    path: "/connect",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                        children: "Welcome to LaceAI"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                        children: "Create an account or log in to continue to your Garmin-ready workouts."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab4d46d455bbee8a$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$444b3ab0cb9aec40), {
                                        to: "/connect",
                                        replace: true
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$GlobalStyle, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$Chrome, {
                children: [
                    shouldShowNavigation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$Header, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$NavBar, {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$Brand, {
                                    to: "/generate",
                                    "aria-label": "LaceAI home",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$BrandLogo, {
                                        src: $19482cc54da0537f$var$brandLogoUrl,
                                        alt: "LaceAI"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$MobileMenuButton, {
                                    type: "button",
                                    onClick: ()=>setIsMobileMenuOpen((open)=>!open),
                                    "aria-expanded": isMobileMenuOpen,
                                    "aria-controls": "primary-navigation",
                                    children: isMobileMenuOpen ? "Close" : "Menu"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$MobileOnlyNavLinks, {
                                    $open: isMobileMenuOpen,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$MobileNavLinks, {
                                        id: "primary-navigation",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                                to: "/connect",
                                                children: "Account"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                                to: "/generate",
                                                children: "Generate"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                                to: "/workouts",
                                                children: "Workouts"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                                to: "/billing",
                                                children: "Billing"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$DesktopNavLinks, {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                            to: "/connect",
                                            children: "Account"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                            to: "/generate",
                                            children: "Generate"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                            to: "/workouts",
                                            children: "Workouts"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$StyledLink, {
                                            to: "/billing",
                                            children: "Billing"
                                        })
                                    ]
                                })
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$Main, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$ContentPanel, {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c700d8a3a13e01e9$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "/",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$444b3ab0cb9aec40), {
                                            to: "/generate",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "/connect",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                            children: "Garmin Account"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                            children: "Link your Garmin account and review connection details used for workout sync."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab4d46d455bbee8a$export$2e2bcd8739ae039), {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "/generate",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                            children: "Generate a Workout"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                            children: "Describe your session in natural language and review the structured plan before sending it to Garmin."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1774e8bb030c4123$export$2e2bcd8739ae039), {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "/workouts",
                                        element: isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                            children: "Your Garmin Library"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                            children: "Track recently generated workouts and drill into the details any time."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $302f2b3a67f1b730$export$2e2bcd8739ae039), {})
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$444b3ab0cb9aec40), {
                                            to: "/connect",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "/workouts/:id",
                                        element: isConnected ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                            children: "Workout Details"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                            children: "Inspect the full Garmin payload so you always know what will be synced to your watch."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fdab0ffcc0242844$export$2e2bcd8739ae039), {})
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$444b3ab0cb9aec40), {
                                            to: "/connect",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "/billing",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                            children: "Billing & Tokens"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                            children: "Manage your Stripe subscription and monitor monthly token usage."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $871411710519ddd4$export$2e2bcd8739ae039), {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageSurface, {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($19482cc54da0537f$var$PageHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionTitle, {
                                                            children: "Page not found"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19482cc54da0537f$var$SectionSubTitle, {
                                                            children: "This LaceAI route does not exist."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28a84c939a5ce9f4$export$2e2bcd8739ae039), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $19482cc54da0537f$export$2e2bcd8739ae039 = $19482cc54da0537f$var$App;




var $acw62 = parcelRequire("acw62");


const $d4646b5a14d1fd4f$var$drift = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
  0% {
    transform: translate3d(-8px, -10px, 0) scale(1);
    opacity: 0.75;
  }
  50% {
    transform: translate3d(10px, 8px, 0) scale(1.06);
    opacity: 1;
  }
  100% {
    transform: translate3d(-8px, -10px, 0) scale(1);
    opacity: 0.75;
  }
`;
const $d4646b5a14d1fd4f$var$glow = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.25);
  }
  50% {
    box-shadow: 0 0 0 18px rgba(37, 99, 235, 0);
  }
`;
const $d4646b5a14d1fd4f$var$shimmer = (0, $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e)`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;
const $d4646b5a14d1fd4f$var$SplashScreen = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: linear-gradient(155deg, #f8fbff 0%, #eef4ff 48%, #fef3f2 100%);
`;
const $d4646b5a14d1fd4f$var$SplashCard = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  width: min(420px, calc(100% - 3rem));
  border-radius: 24px;
  padding: 2.25rem;
  text-align: center;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(8px);
  box-shadow: 0 20px 55px rgba(15, 23, 42, 0.12);
`;
const $d4646b5a14d1fd4f$var$ColorOrb = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: absolute;
  width: 110px;
  height: 110px;
  border-radius: 999px;
  filter: blur(1px);
  background: radial-gradient(circle at 32% 32%, #3b82f6 0%, #8b5cf6 62%, #f97316 100%);
  top: ${(props)=>props.$top ?? "auto"};
  left: ${(props)=>props.$left ?? "auto"};
  right: ${(props)=>props.$right ?? "auto"};
  animation: ${$d4646b5a14d1fd4f$var$drift} 4.2s ease-in-out infinite;
  animation-delay: ${(props)=>props.$delay ?? "0s"};
  opacity: 0.8;
`;
const $d4646b5a14d1fd4f$var$LogoWrap = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  position: relative;
  width: 94px;
  height: 94px;
  margin: 0 auto 1.1rem;
  border-radius: 18px;
  background: #ffffff;
  display: grid;
  place-items: center;
  animation: ${$d4646b5a14d1fd4f$var$glow} 1.8s ease-out infinite;
`;
const $d4646b5a14d1fd4f$var$LogoImage = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).img`
  width: 68px;
  height: 68px;
`;
const $d4646b5a14d1fd4f$var$Heading = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).h1`
  margin: 0;
  font-size: 1.35rem;
  color: #0f172a;
`;
const $d4646b5a14d1fd4f$var$Subheading = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).p`
  margin: 0.7rem 0 1.4rem;
  color: #475569;
  font-size: 0.95rem;
`;
const $d4646b5a14d1fd4f$var$LoadingBar = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  height: 7px;
  border-radius: 999px;
  overflow: hidden;
  background-color: #dbeafe;

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg, #60a5fa 0%, #2563eb 38%, #f97316 76%, #60a5fa 100%);
    background-size: 200% 100%;
    animation: ${$d4646b5a14d1fd4f$var$shimmer} 1.25s linear infinite;
  }
`;
var $b317fd0ea794b0a5$exports = {};
$b317fd0ea794b0a5$exports = import.meta.resolve("dicEm");


const $d4646b5a14d1fd4f$var$logoUrl = new URL($b317fd0ea794b0a5$exports).toString();
function $d4646b5a14d1fd4f$export$f6a06b563a614935({ children: children }) {
    const [isAuthCheckComplete, setIsAuthCheckComplete] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { actions: { checkAuth: checkAuth } } = (0, $57125122a3ba2ea1$export$650ce9f0b4df82fd)();
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const runBootstrap = async ()=>{
            const minimumSplashTime = new Promise((resolve)=>setTimeout(resolve, 900));
            await Promise.all([
                checkAuth(),
                minimumSplashTime
            ]);
            if (isMounted) setIsAuthCheckComplete(true);
        };
        runBootstrap();
        return ()=>{
            isMounted = false;
        };
    }, [
        checkAuth
    ]);
    if (!isAuthCheckComplete) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$SplashScreen, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d4646b5a14d1fd4f$var$SplashCard, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$ColorOrb, {
                    $top: "-24px",
                    $left: "-26px"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$ColorOrb, {
                    $top: "-16px",
                    $right: "-20px",
                    $delay: "-1.5s"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$LogoWrap, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$LogoImage, {
                        src: $d4646b5a14d1fd4f$var$logoUrl,
                        alt: "LaceAI"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$Heading, {
                    children: "LaceAI"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$Subheading, {
                    children: "Warming up your next Garmin-ready session..."
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d4646b5a14d1fd4f$var$LoadingBar, {
                    "aria-hidden": "true"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children
    });
}



const $0a45d581d4716ff1$var$Container = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  min-height: 100vh;
  background-color: #ffffff;
  color: #1e293b;
  font-family: "Inter", "Segoe UI", sans-serif;
`;
const $0a45d581d4716ff1$var$Header = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
const $0a45d581d4716ff1$var$Logo = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: bold;
`;
const $0a45d581d4716ff1$var$Main = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).main`
  padding: 5rem 1.5rem;
  max-width: 64rem;
  margin: 0 auto;
  text-align: center;
`;
const $0a45d581d4716ff1$var$Section = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).section`
  padding: 4rem 1.5rem;
  background-color: ${(props)=>props.bg || "transparent"};
`;
const $0a45d581d4716ff1$var$Footer = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).footer`
  padding: 4rem 1.5rem;
  background-color: #f9fafb;
  font-size: 0.875rem;
  color: #475569;
`;
const $0a45d581d4716ff1$var$Button = (0, $f8dbcd8598db1f0b$export$2e2bcd8739ae039).a`
  display: inline-block;
  background-color: #2563eb;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1d4ed8;
  }
`;
function $0a45d581d4716ff1$var$Home() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($0a45d581d4716ff1$var$Container, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($0a45d581d4716ff1$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a45d581d4716ff1$var$Logo, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: "./logo300x300.png",
                            alt: "LaceAI Logo",
                            style: {
                                height: "120px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$a6c7ac8248d6e38a), {
                        to: "#contact",
                        children: "Contact"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($0a45d581d4716ff1$var$Main, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        style: {
                            fontSize: "2.25rem",
                            fontWeight: "bold",
                            marginBottom: "1rem"
                        },
                        children: "AI-powered Garmin Workouts from Plain Text"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: {
                            fontSize: "1.125rem",
                            color: "#64748b",
                            marginBottom: "2rem"
                        },
                        children: "Type a workout in natural language. LaceAI converts it into a structured Garmin session."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a45d581d4716ff1$var$Section, {
                bg: "#f1f5f9",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxWidth: "48rem",
                        margin: "0 auto",
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            style: {
                                fontSize: "1.5rem",
                                fontWeight: "600",
                                marginBottom: "1.5rem"
                            },
                            children: "How It Works"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ol", {
                            style: {
                                paddingLeft: "1.25rem",
                                color: "#475569",
                                lineHeight: "1.75"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                    children: [
                                        "Write something like:",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                            style: {
                                                backgroundColor: "#e2e8f0",
                                                padding: "0 0.25rem"
                                            },
                                            children: "15 min warmup, 5x1km @ 4:00/km, 90s jog, cool down"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "LaceAI parses it into a structured workout."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "We sync it to your Garmin using their Training API."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a45d581d4716ff1$var$Section, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxWidth: "48rem",
                        margin: "0 auto",
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            style: {
                                fontSize: "1.5rem",
                                fontWeight: "600",
                                marginBottom: "1.5rem"
                            },
                            children: "Features"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                            style: {
                                paddingLeft: "1.25rem",
                                color: "#475569",
                                lineHeight: "1.75"
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Natural language to structured Garmin workout"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Supports intervals, pace, heart rate zones"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "Export to Garmin-compatible format"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                    children: "No manual workout programming needed"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a45d581d4716ff1$var$Section, {
                bg: "#f1f5f9",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxWidth: "48rem",
                        margin: "0 auto",
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            style: {
                                fontSize: "1.5rem",
                                fontWeight: "600",
                                marginBottom: "1.5rem"
                            },
                            children: "Project Status"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                color: "#475569"
                            },
                            children: "LaceAI is currently in closed beta. We are ready to integrate with the Garmin Training API and awaiting approval. This project is built for runners by runners."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0a45d581d4716ff1$var$Footer, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    style: {
                        maxWidth: "48rem",
                        margin: "0 auto",
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            style: {
                                fontSize: "1.5rem",
                                fontWeight: "600",
                                marginBottom: "1rem"
                            },
                            children: "Contact"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "Reach out:",
                                " ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                    href: "mailto:alex@laceai.run",
                                    style: {
                                        color: "#2563eb"
                                    },
                                    children: "alex@laceai.run"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                            style: {
                                marginTop: "1rem"
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$a6c7ac8248d6e38a), {
                                to: "/privacy",
                                style: {
                                    color: "#2563eb"
                                },
                                children: "Privacy Policy"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function $0a45d581d4716ff1$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $57125122a3ba2ea1$export$e1d3eeccb965c5c3), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4646b5a14d1fd4f$export$f6a06b563a614935), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c700d8a3a13e01e9$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19482cc54da0537f$export$2e2bcd8739ae039), {})
            })
        })
    });
}


// import "./styles.css";
const $fae044756a3baaec$var$root = (0, $7e96a608cb33bf79$exports.createRoot)(document.getElementById("root"));
$fae044756a3baaec$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0a45d581d4716ff1$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=web.70dca210.js.map
